// Mensagens de erro do servidor por código (en). Gerado a partir de `scripts/extrair-codigos-erro.mjs`;
// o teste `tests/i18n-codigos-erro.test.ts` falha se um código do backend ficar sem tradução.
// Chave plana com ponto literal (códigos como 'a' e 'a.b' convivem). Curinga: '*.invalida' vale para
// `${campo}.invalida` e 'funcionario.ja_*' para `funcionario.ja_${estado}`. `{{campo}}` só para chave de meta que o servidor envia.
export const errosEn: Record<string, string> = {
  // Fase 2, W23: funcionário ligado a parceiro (K10) e card criado a partir de um registro (K11).
  'erro_log.nao_encontrado': 'Error not found in the log',
  'card.vinculo_nao_encontrado': 'Linked record not found',
  'parceiro.documento_invalido': 'Invalid CPF or CNPJ',
  'parceiro.setor_invalido': 'Segment not found',
  'parceiro.documento_duplicado_outra_empresa': 'A partner with this document already exists in a company you cannot see',
  'funcionario.parceiro_ja_existe': 'The employee is already linked to a partner',
  'funcionario.empresa_padrao_invalida': 'The company chosen for the rows without company is not among the ones you see',
  'funcionario.empresa_vazia': 'Empty company: the row goes to the current company. Choose the company for the rows without company',
  'funcionario.ja_tem_acesso': 'This employee already has access to the system',
  'funcionario.papel_obrigatorio': 'The role has no permission profile: choose the profile of the invitation',
  'funcionario.sem_email': 'Fill in the email of the employee in the record to invite',
  'cpf.obrigatorio': 'The CPF cannot be removed once informed',
  'competencia.sem_funcionarios_completos': 'No employee with CPF and hire date for this period: complete the details in the People record',
  'funcionario.sem_cpf': 'Fill in the CPF of the employee in the record to create the partner',
  'funcionario.dados_a_completar': 'Record with details to complete (CPF or hire date): Payroll skips the employee until completed',
  'funcionario.empresa_nao_encontrada': 'Company not found among the ones you see (use the name or the CNPJ)',
  'vinculo.admissao_obrigatoria': 'To add the employment at another company, inform the hire date',
  'funcionario.linha_repetida': 'Same person as an earlier row (same CPF, or same email without CPF, at the same company): row skipped. If it is another company of the group, fill in the Company column',
  'funcionario.sem_chave': 'No CPF and no email: importing again creates another record',
  'funcionario.telefone_ilegivel': 'Unreadable phone: left out',
  'funcionario.celular_ilegivel': 'Unreadable mobile: left out',
  'funcionario.gestor_varias_pessoas': 'Manager with several people: choose in the record',
  'funcionario.gestor_homonimo': 'More than one employee with the name of the manager: choose in the record',
  'funcionario.gestor_nao_encontrado': 'Manager not found among the employees: choose in the record',
  'funcionario.gestor_nome_nao_encontrado': 'One of the manager names was not found among the employees: the line has no manager; choose the managers in the department',
  'funcionario.gestor_nome_ambiguo': 'One of the manager names matches more than one employee: the line has no manager; choose the managers in the department',
  'funcionario.gestor_sem_departamento': 'Manager with several people and a line with no department: no department manager; choose in the record',
  'funcionario.jornada_sem_calendario': 'No calendar with the weekly hours of the schedule: choose in the record',
  'funcionario.jornada_varios_calendarios': 'More than one calendar with the weekly hours of the schedule: choose in the record',
  // Phase 2, W24 (K9): summary category, payment reversal from the document and the Miscellaneous partner.
  'categoria.sintetica': 'The category is a summary (it only groups its children): choose a detail category',
  'categoria.sintetica_em_uso': 'The category already has entries or is in use: only an unused category can become a summary',
  'categoria.sintetica_papel': 'The automatic-use category takes the payment lines: it cannot be a summary',
  'baixa.conector_desconhecido': 'It was not possible to tell which Asaas connector this payment came through: refund it in Asaas and then reverse the payment here without refunding through Asaas',
  'baixa.sem_asaas': 'This payment did not come from Asaas: there is nothing to refund there',
  'baixa.sem_lancamento': 'This payment has no entry in Finance to reverse',
  'baixa.estorno_recusado': 'Finance refused to reverse the payment entry',
  'conta.tipo_invalido': 'Type must be bank, cash, card, investment or savings',
  'cadastros.indisponivel': 'The Records module is not available',
  // Phase 2, W14 (Receivables): renegotiation (F6) and write-off reversal.
  'documento.renegociado': 'This document was renegotiated: the balance is in the new installments',
  'documento.nao_perdido': 'This document is not written off',
  'perda.estorno_antes_da_perda': 'The reversal cannot be dated before the write-off',
  'baixa.renegociacao_sem_estorno': 'A renegotiation cannot be reversed',
  'renegociacao.tipo_invalido': 'Only invoices and bills can be renegotiated',
  'renegociacao.tipos_diferentes': 'Renegotiate invoices and bills separately',
  'renegociacao.parceiros_diferentes': 'The documents in a renegotiation belong to the same customer or supplier',
  'renegociacao.moedas_diferentes': 'The documents in a renegotiation use the same currency',
  'renegociacao.empresas_diferentes': 'The documents in a renegotiation belong to the same company',
  'renegociacao.vencimento_anterior': 'The first installment cannot be due before the renegotiation',
  'renegociacao.desconto_invalido': 'The discount must be lower than the balance plus the agreed charges',
  // Fase 2, W15: team chat (Equipe module).
  'canal.nao_encontrado': 'Channel not found',
  'canal.nao_participa': 'You are not in this channel: join it to write',
  'canal.arquivado': 'The channel is archived (read only)',
  'canal.nome_obrigatorio': 'Give the channel a name',
  'canal.nome_longo': 'Channel name with up to 80 characters',
  'canal.nome_duplicado': 'A channel with this name already exists',
  'canal.departamento_invalido': 'Only a department channel has a department',
  'canal.visibilidade_fixa': 'A record discussion is always private',
  'canal.direta_sem_saida': 'You cannot leave a direct conversation',
  'canal.ultimo_dono': 'The channel needs at least one owner',
  'canal.conflito': 'The discussion was just opened; try again',
  'direta.mesma_pessoa': 'Pick someone else for the direct conversation',
  'direta.pessoa_sem_acesso': 'This person does not use the team chat',
  'direta.conflito': 'The conversation was just opened; try again',
  'participante.nao_encontrado': 'This person is not in the channel',
  'mensagem.nao_encontrado': 'Message not found',
  'mensagem.de_outra_pessoa': 'Only the author can change or delete the message',
  'mensagem.apagada': 'The message was deleted',
  'mensagem.resposta_invalida': 'The quoted message is not from this channel',
  'anexo.outro_canal': 'Some attachment was not uploaded to this channel',
  'anexo.de_outra_pessoa': 'Only attachments you uploaded can go in your message',
  'anexo.ja_usado': 'This attachment is already in another message',
  'anexo.muito_grande': 'File too large (up to 25 MB)',
  'anexo.vazio': 'The file is empty',
  'anexo.tipo_nao_permitido': 'File type not allowed',
  // Fase 2, W7: DRE, apropriação, perda, tarifa, importação de títulos, rateio e agregados.
  'agregado.invalido': 'Invalid aggregation filter',
  'agregado.periodo_invalido': 'The period goes from 1 day to 3 years',
  'exportacao.arquivo_ausente': 'The file of this export is no longer available on the server',
  'exportacao.nao_encontrado': 'Export not found',
  'exportacao.nao_pronta': 'The export has not finished yet',
  // Fase 2 (W21, K7): "Update indices now" requested again within 10 minutes.
  'indices.atualizacao_recente': 'The indices were requested a moment ago. Try again in a few minutes',
  'relatorio.data_invalida': 'Invalid date (use YYYY-MM-DD)',
  'relatorio.periodo_invalido': 'The period goes from 1 day to 3 years',
  'relatorio.periodo_longo': 'With this grouping, the period goes up to {{dias}} days',
  'relatorio.cliente_filtro': 'The customer\'s position brought an invoice of another partner; nothing was sent',
  'relatorio.portal_inelegivel': 'This report cannot go to the client portal: only Delinquency (customer position) and By customer (customer statement) are per customer',
  'portal.relatorio_ja_publicado': 'This report is already published for this customer',
  'portal.relatorio_nao_encontrado': 'Publication not found',
  'relatorio.portal_indisponivel': 'The client portal is not installed in this workspace',
  'relatorio_salvo.dia_invalido': 'Choose the delivery day',
  'relatorio_salvo.limite': 'Limit of {{max}} saved reports reached. Delete one before saving another.',
  'relatorio_salvo.nao_encontrado': 'Saved report not found',
  'relatorio_salvo.papel_invalido': 'Role not found',
  'relatorio_salvo.periodo_invalido': 'This report is by date, not by period',
  'relatorio_salvo.pessoa_invalida': 'Person not found among the workspace members',
  'relatorio_salvo.sem_destinatarios': 'Choose at least one recipient',
  'relatorio_salvo.sem_papeis': 'Choose at least one role',
  'relatorio_salvo.sem_pessoas': 'Choose at least one person',
  'relatorio.parametros_invalidos': 'Invalid report parameters',
  'relatorio.fonte_indisponivel': 'The source module of this report is not available',
  'relatorio.categoria_invalida': 'Invalid category',
  'apropriacao.componente_invalido': 'Invalid allocation line: the discount is negative and the other components positive',
  'apropriacao.soma_diferente': 'The allocation total does not match the entry amount',
  'baixa.perda_sem_estorno': 'A write-off has no entry to reverse',
  'categoria.destino_invalido': 'Choose another active category of the same type to receive the entries',
  'categoria.grupo_invalido': 'Invalid income statement group',
  'categoria.natureza_invalida': 'Nature must be income, expense, asset, liability or neutral',
  'categoria.papel_invalido': 'Invalid automatic use for this category (wrong type or inactive category)',
  'chave_externa.duplicado': 'A document with this external key already exists',
  'contas.indisponivel': 'The Receivables and payables module is not installed',
  'parceiro.nao_fornecedor': 'The partner is not a supplier: mark Supplier in the record before the purchase terms',
  'pedido_minimo.invalido': 'The minimum order must be a positive amount',
  'documento.perda_so_fatura': 'Only an invoice (receivable) can be written off',
  'documento.perdido': 'This document was already written off',
  'extrato.nao_fecha': 'The statement does not match the account balance: contact support',
  'importacao.cabecalho_invalido': 'The CSV is missing the required columns (chave_externa, documento_parceiro, vencimento and valor): download the template',
  'importacao.linhas_demais': 'At most 5000 lines per file',
  'importacao.tipo_invalido': 'Type must be fatura, conta_pagar, nota_credito or reembolso',
  'importacao.chave_obrigatoria': 'Enter the external key (the document code at the source)',
  'importacao.chave_repetida': 'External key repeated in the file',
  'importacao.repetido_no_arquivo': 'Repeated in the file: the same value already came in an earlier line (only the first one is saved)',
  'importacao.parceiro_nao_encontrado': 'No partner with this tax ID: register it or fix the document',
  'importacao.data_invalida': 'Invalid date: use DD/MM/YYYY or YYYY-MM-DD',
  'importacao.valor_invalido': 'Invalid value for this column (amounts: use 1.234,56)',
  'importacao.categoria_nao_encontrada': 'Category not found: use the code or name of an active category of the right type',
  'importacao.centro_nao_encontrado': 'Cost center not found: use the code or the name',
  'importacao.conta_nao_encontrada': 'Account not found: use the name of an active account',
  'lote.sentidos_diferentes': 'The batch mixes receivables and payables: split it into two batches',
  'rateio.invalido': 'Invalid split: each cost center once, parts with up to 4 decimals adding up to 100%, and not together with a single cost center',
  'competencia.centro_custo_invalido': 'There is a cost center deleted or inactive in Finance. Adjust it in Cost centers by department and calculate again',
  'competencia.fechamento_recusado': 'The closing was refused and the period went back to reviewed. Fix it and close again.',
  'escopo.excede_chave': 'The API key cannot grant permissions outside its own scope',
  'funcionario.gestor_ciclo': 'This would create a cycle in the chain of managers',
  'permissao.dono_tenant': 'Only IT in a production (non-sandbox) workspace can do this, because it applies to the whole company',
  '*.caractere_invalido': 'Contains an invisible or control character in the middle of the text',
  '*.duplicado': 'There is already one with this name',
  '*.invalida': 'Invalid date or value',
  'interativo.*': 'Button or quick reply outside the channel rules (count, label, link or code)',
  '*.invalido': 'Invalid value',
  '*.muito_longo': 'Too long: up to {{max}} characters',
  '*.nao_encontrado': 'Not found',
  '*.obrigatorio': 'This field is required',
  '*.transicao_invalida': 'This status change is not allowed',
  '*.variavel_invalida': 'Malformed variable. Use lowercase letters, numbers and underscores',
  'admissao.obrigatoria': 'Hire date is required',
  'agenda.google_calendario_invalido': 'This calendar is not one the connected Google account can edit',
  'agenda.google_pessoal_desconectado': 'Your Google Calendar is not connected',
  'agenda.google_nao_configurado': 'Google access has not been set up on the server yet. Talk to the system administrator',
  'agenda.profissional_nao_criado': 'The professional could not be created. Talk to whoever manages the Schedule',
  'agenda.google_desconectado': 'Connect Google Calendar in Integrations > Connectors to choose the calendars',
  'agenda.google_indisponivel': 'Could not reach Google right now. Try again in a moment',
  'agenda.google_recusado': 'Google refused access for the connected account. Reconnect in Integrations > Connectors',
  'agenda.profissional_desativado': 'Your staff profile in the Schedule is deactivated or in another company. Talk to whoever manages the Schedule',
  'reuniao.convites_demais': 'Too many Google invitations at once: reduce the repetitions or the guests.',
  'agendamento.duracao_longa': 'The meeting cannot last more than 31 days',
  'gravacao.sem_cliente': 'This meeting has no customer: the transcript cannot be published to the Portal',
  'agenda.indisponivel': 'Install the Schedule module to book appointments',
  'agendamento.ainda_nao_comecou': 'The appointment has not started yet',
  'agendamento.conflito': 'This resource is already booked at this time',
  'agendamento.fora_do_horario': 'This time is outside the resource\'s working hours',
  'link_reuniao.invalido': 'The meeting link must be an http or https address',
  'link_reuniao.obrigatorio': 'Enter the meeting link',
  'reuniao.meet_indisponivel': 'Google Meet needs Google Calendar connected in Integrations > Connectors and a Google calendar chosen for this professional or resource',
  'gravacao.nao_encontrada': 'Recording not found',
  'gravacao.expirada': 'The recording is past its retention period and no longer exists on the video server',
  'gravacao.arquivo_ausente': 'This file does not exist in this recording',
  'gravacao.sem_conector': 'Connect the meeting room in Integrations > Connectors to open or send the recording',
  'gravacao.sem_destinatario': 'No one to receive it: the customer has no e-mail and there are no guests or e-mails entered',
  'gravacao.portal_indisponivel': 'The Customer Portal is not installed in this workspace',
  'gravacao.sem_transcricao': 'This recording has no transcript to publish in the Portal',
  'sala.segredo_recusado': 'The video server rejected the secret: check that it matches malgo-pos.env',
  'sala.prefixo_desconhecido': 'The video server does not know this prefix: add it to malgo-pos.env and restart malgo-pos',
  // U14 F3: WhatsApp pela Zernio.
  'zernio.sem_numero': 'The Zernio key is valid; the WhatsApp number is not connected yet ("Connect number" button)',
  'zernio.pagamento': 'The Zernio account is paused for payment: settle it in the Zernio dashboard',
  'zernio.perfil_desconhecido': 'Zernio does not know the saved profile: clear the profile field and use "Connect number" again',
  'zernio.conta_desconhecida': 'The saved WhatsApp account is no longer in the Zernio profile: clear the account field and use "Connect number"',
  'zernio.reconectar': 'Zernio asks to reconnect the number: use "Connect number"',
  'zernio.numero_desconectado': 'The number was disconnected at Zernio: connect it again from the card in Integrations > Connectors',
  'reuniao.sala_nao_configurada': 'Set up the meeting room server in Records > Schedule > Staff and resources before using your own room',
  'reuniao.sala_base_invalida': 'The video server address must start with https:// and cannot contain ? or #',
  'convidados.muitos': 'At most {{max}} guests',
  'convidados.email_invalido': 'Invalid guest e-mail',
  'convidados.nome_invalido': 'Invalid guest name',
  'convidados.membro_nao_encontrado': 'Team guest not found',
  'convidados.contato_nao_encontrado': 'Guest contact not found in the records',
  'agendamento.nao_cancelado': 'Could not cancel the appointment',
  'agendamento.nao_criado': 'Could not create the appointment',
  'agendamento.nao_encontrado': 'Appointment not found',
  'agendamento.so_cancelado': 'Only a canceled appointment can be deleted: cancel it first',
  'agendamento.sincronizacao_pendente': 'The cancellation has not reached Google Calendar yet: try again in a few minutes',
  'agendamento.em_uso': 'The appointment is in use and cannot be deleted',
  'agendamento.recusado': 'The appointment was refused',
  'agendamento.transicao_invalida': 'The appointment cannot change to this status',
  'anexo.arquivo_ausente': "This attachment's file is no longer available on the server",
  'anexo.duplicado': 'An attachment with this id already exists',
  'anexo.nao_encontrado': 'Attachment not found',
  'anexo.provedor_nao_encontrado': 'The file is no longer at the email provider: the email was deleted or left the mailbox. The name and size are still here.',
  'anexo.provedor_indisponivel': 'The email provider did not deliver the file right now (connector disconnected or provider down). Try again in a moment.',
  'anexo.provedor_limite': 'You already have files downloading from the email provider. Wait for them to finish and try again.',
  'anexo.provedor_ocupado': 'Too many files downloading from the email provider right now. Try again in a moment.',
  'caixa.dono_obrigatorio': 'A personal mailbox needs an owner',
  'caixa.sem_delegacao': 'A support mailbox is read through queues: it has no delegation',
  'caixa.bloqueada': 'The mailbox is blocked because its owner was dismissed: transfer it to someone else or close it',
  'caixa.nao_bloqueada': 'The mailbox is not waiting for the dismissal decision',
  'caixa.mesmo_dono': 'Choose someone else: this is the dismissed person',
  'conversa.caixa_restrita': 'A conversation from a personal or department mailbox does not go to a queue and cannot be transferred',
  'delegacao.ao_dono': 'The owner already reads the personal mailbox',
  'delegacao.duplicado': 'This person already has delegated access to this mailbox',
  'delegacao.nao_encontrado': 'Delegation not found',
  'permissao.caixa_pessoal_so_dono': 'Only the owner of a personal mailbox changes its type, owner or delegations',
  'permissao.caixa_corporativa_delegar': 'Only someone who sees all conversations (Administrator or Manager) delegates a department mailbox',
  'permissao.caixa_ver_todas': 'Only someone who sees all conversations (Administrator or Manager) changes the type or owner of this mailbox',
  'parceiro.obrigatorio': 'Conversation without the contact in Records',
  'conversa.sem_contato': 'This conversation has no contact in Records: register the contact first',
  'caixa.nao_encontrado': 'This mailbox is not among the ones the email connector monitors',
  'anexo.outro_registro': 'Some attachment does not belong to this record',
  'aparencia.modelo_invalido': 'Model not found in this workspace',
  'modelo.base_invalida': 'Invalid starting mode',
  'modelo.contraste': 'Some color pairs in the model do not have enough contrast',
  'modelo.cor_invalida': 'Use six-digit hexadecimal colors',
  'modelo.id_invalido': 'Invalid model',
  'modelo.limite': 'The workspace reached the model limit',
  'modelo.tela_antiga': 'Reload the page to save the models',
  'modelo.nome_repetido': 'A model with this name already exists',
  'aparencia.acento_invalido': 'Invalid brand color',
  'aparencia.idioma_invalido': 'Invalid default language',
  'aparencia.tema_invalido': 'Invalid default theme',
  'arquivo.obrigatorio': 'Upload a file',
  'assunto.muito_longo': 'The subject is over 300 characters',
  'assunto.obrigatorio': 'The email template needs a subject',
  'atalho.duplicado': 'A reply with this shortcut already exists',
  'atalho.invalido': 'Use only letters, numbers, hyphens and underscores (up to 30)',
  'atalho.obrigatorio': 'Enter the shortcut',
  'atendente.nao_encontrado': 'This agent is not a member of this workspace',
  'atividade.agendamento_incompleto': 'To schedule the meeting, enter the resource and the service together',
  'atividade.reuniao_livre_com_servico': 'A free-form meeting takes no resource or service',
  'agenda.evento_google_sumiu': 'This event no longer exists in Google Calendar',
  'agenda.evento_google_mudou': 'This event changed in Google Calendar while you were editing. Open it again to see the current version',
  'agenda.evento_google_so_leitura': 'This event cannot be changed here',
  'agenda.google_em_sincronia': 'Google Calendar is syncing right now. Try again in a moment',
  'atividade.estado_invalido': 'The activity is already in this status',
  'atividade.nao_cancelada': 'Only a canceled task can be reopened',
  'atividade.nao_encontrado': 'Activity not found',
  'atributo.em_uso': 'Some variations use this attribute',
  'atributo.nao_encontrado': 'Attribute not found',
  'atributo.nome_duplicado': 'An attribute with this name already exists',
  'atributo.valor_duplicado': 'This value already exists on the attribute',
  'auditoria.nao_encontrado': 'Audit record not found',
  'aula.biblioteca_invalida': 'Invalid video library',
  'aula.biblioteca_obrigatoria': 'Enter the video library',
  'aula.bloqueada': 'Complete the prerequisite lesson first',
  'aula.em_uso': 'Some lessons require this one as a prerequisite',
  'aula.modulo_invalido': 'The module must belong to the same course',
  'aula.nao_encontrado': 'Lesson not found',
  'aula.pre_requisito_ciclo': 'This prerequisite would create a loop between lessons',
  'aula.pre_requisito_invalido': 'Invalid lesson prerequisite',
  'aula.provedor_indisponivel': 'This video provider is not enabled in the Video players connector. Enable it in Integrations.',
  'aula.provedor_invalido': 'Invalid video provider: use youtube, vimeo, panda or bunny',
  'aula.tipo_invalido': 'Invalid lesson type: use video or text',
  'aula.tela_invalida': 'Invalid screen: use the module/tab format (e.g. contas/a-receber) or inicio',
  'aula.video_id_invalido': 'Enter a valid video id',
  'auth.bloqueado': 'Too many attempts. Try again later.',
  'auth.credenciais_invalidas': 'Incorrect e-mail, username or password',
  'auth.troca_senha_obrigatoria': 'Change the temporary password to continue',
  'conta.acao_propria': 'For your own access, use My account > Security',
  'conta.tem_email': 'This account has an e-mail: the person recovers the password with the "Forgot password" link',
  'simulacao.encerrada': 'The simulation ended: the screen goes back to your account',
  'simulacao.acao_recusada': 'This action is not available during the simulation: go back to your account',
  'simulacao.perfil_nao_permitido': 'A test account cannot be IT nor have administration or anything that requires two-step verification: adjust the roles first',
  'simulacao.conta_nao_de_teste': 'You can only simulate a test user of this workspace',
  'simulacao.ja_ativa': 'There is already a simulation in this session: go back to your account first',
  'simulacao.propria': 'You are already yourself: choose a test user',
  'usuario_teste.tem_email': 'Only an account without email (sign in by username) can become a test user',
  'usuario_teste.outro_workspace': 'This account is also a member of another workspace: it cannot become a test user',
  'usuario_teste.sem_login': 'A test user has no sign in of its own: unmark "Test user" before giving it a password or email',
  'usuario_simulacao.protegido': 'The simulation user does not change here: it follows the role, has no sign in of its own and cannot be IT',
  'usuario_teste.ja_entrou': 'This account has already signed in: only an account without email that never signed in can become a test user (create a new access for testing)',
  'permissao.conta_outro_workspace': 'This person is also a member of another workspace: their e-mail and password only change with them or with IT there',
  'email.mesmo': 'This is already the account e-mail',
  'email.troca_limite': 'Too many e-mail change requests in the last hour: wait to ask again',
  'email.em_uso': 'This address now belongs to another account: ask for the change with another e-mail',
  'permissao.conta_plataforma': 'This account administers the platform: only its owner changes its e-mail and password',
  'permissao.conta_empresas_fora': 'This person sees companies you do not see: their e-mail and password only change with someone who sees all their companies',
  'permissao.conta_acima_do_ator': 'This person has access you do not have: their e-mail, password and second factor only change with someone who has all their access',
  'email.troca_por_pedido': 'Changing your e-mail goes through a request: ask in My account > Profile and an administrator approves it',
  'usuario.troca_por_pedido': 'Changing your username goes through a request: ask in My account > Profile and an administrator approves it',
  'email.troca_recusada': 'This request is no longer valid: the person who asked can no longer change this account\'s e-mail',
  'acesso.duplicado': 'This access has already been created. For another password, use New temporary password on the member.',
  'usuario.invalido': 'Invalid username: use 2 to 40 unaccented letters, digits, dot, hyphen or underscore, no "@"',
  'usuario.obrigatorio': 'Enter the username',
  // Val7 (29/10): sign-in methods (sign-in e-mail and username).
  'acesso.ultima_forma': 'The person needs at least one active sign-in method',
  'acesso.sem_email': 'This account has no e-mail: add one through the e-mail change request (confirmed by the link)',
  'acesso.forma_obrigatoria': 'Choose at least one sign-in method',
  'usuario.em_uso': 'This username is already taken: choose another one',
  'senha.link_limite': 'Too many password links sent to this person in the last hour: wait to send again',
  'auth.nao_autenticado': 'Your session is missing or has expired',
  'auth.sem_workspace': 'User has no active workspace',
  'auth.so_sessao': 'This route is for logged-in sessions only',
  'auth.token_invalido': 'Invalid or expired link',
  'baixa.acima_do_saldo': 'The payment amount is above the document balance',
  'baixa.data_anterior_emissao': 'The payment date cannot be before the issue date',
  'baixa.data_futura': 'The payment date cannot be in the future',
  'baixa.desconto_invalido': 'The discount must be lower than the payment amount with interest and fines',
  'baixa.estorno_acima_do_valor': 'Reversing this payment would exceed the document amount',
  'baixa.id_externo_duplicado': 'This payment identifier has already settled another document',
  'baixa.ja_estornada': 'This payment was already reversed',
  // Phase 2, W34: apply credit note to invoice.
  'aplicacao.valor_invalido': 'The applied amount must be greater than zero',
  'aplicacao.acima_do_saldo': 'The applied amount is above the document balance',
  'aplicacao.acima_do_saldo_fatura': 'The applied amount is above the invoice balance',
  'aplicacao.acima_do_saldo_nota': 'The total applied is above the credit note balance',
  'aplicacao.acima_do_valor': 'Undoing the application would put the balance above the document amount',
  'aplicacao.documento_perdido': 'The invoice was written off: reverse the write-off before undoing the application',
  'aplicacao.nao_e_nota': 'Only a credit note can be applied to an invoice',
  'aplicacao.nao_e_fatura': 'Credit can only be applied to a receivable invoice',
  'aplicacao.parceiro_diferente': 'The invoice belongs to another customer',
  'aplicacao.empresa_diferente': 'The invoice belongs to another company',
  'aplicacao.moeda_diferente': 'The invoice is in another currency',
  'aplicacao.fatura_repetida': 'Each invoice appears once in the application',
  'aplicacao.sem_faturas': 'Choose at least one invoice',
  'aplicacao.faturas_demais': 'At most 50 invoices per application',
  'aplicacao.data_futura': 'The application date cannot be in the future',
  'aplicacao.data_anterior_emissao': 'The application date cannot be before the issue date of the credit note or the invoice',
  'aplicacao.ja_desfeita': 'This application was already undone',
  'aplicacao.nao_encontrado': 'Application not found on this document',
  'aplicacao.motivo_obrigatorio': 'Enter the reason to undo the application',
  'baixa.lancamento_recusado': 'Finance refused the entry',
  'baixa.nao_encontrado': 'This payment does not belong to this document',
  'baixa.valor_invalido': 'Invalid payment amount',
  'banco.ocupado': 'The system is busy. Try again in a moment.',
  'beneficio.alvo_obrigatorio': 'Choose at least one employee or role.',
  'beneficio.aplica_a_invalido': 'Choose employee or role',
  'beneficio.desconto_invalido': 'Check the employee deduction.',
  'beneficio.forma_invalida': 'Invalid form',
  'beneficio.nao_encontrado': 'Benefit not found',
  'beneficio.nome_duplicado': 'A benefit with this name already exists.',
  'beneficio.pessoas_indisponivel': 'The People module is not installed',
  'beneficio.tipo_invalido': 'Invalid benefit type',
  'bloqueio.conflito': 'There are appointments in this period. Reschedule or cancel them first, or force the block',
  'bloqueio.nao_encontrado': 'Block not found',
  'bloqueio.origem_google': 'This block comes from Google Calendar; change the event there',
  'calendario.em_uso': 'There are employees on this calendar',
  'calendario.nao_encontrado': 'Calendar not found',
  'calendario.nome_duplicado': 'A calendar with this name already exists',
  'campo.chave_duplicada': 'A field with this key already exists on this entity',
  'campo.entidade_invalida': 'This entity has no custom fields',
  'campo.invalido': 'Invalid value in this field',
  'campo.modulo_inativo': 'The module for this field is not installed',
  'campo.nao_encontrado': 'Field not found',
  'campo.obrigatorio': 'This field is required',
  'campo_tela.campo_desconhecido': 'This field does not exist on this screen',
  'campo_tela.escondido_obrigatorio': 'A hidden field cannot be required',
  'campo_tela.nao_esconde': 'This field cannot be hidden',
  'campo_tela.nao_obriga': 'This field cannot be required',
  'campo_tela.tela_desconhecida': 'Unknown screen, or its module is not installed',
  'campo_tela.travado': 'This field is used in rules, reports or integrations and cannot change',
  'canal.invalido': 'Invalid channel',
  'categoria.ciclo': 'A category cannot be its own parent',
  'categoria.codigo_duplicado': 'A category with this code already exists',
  'categoria.em_uso': 'The category has entries or child categories: deactivate it instead of removing',
  'categoria.profundidade': 'The chart of accounts goes down to {{max}} levels: pick a parent higher up',
  'categoria.em_uso#tipo': 'The type cannot change while the category has entries or child categories',
  'categoria.inativa': 'The category is inactive',
  'categoria.nao_encontrado': 'Category not found',
  'categoria.pai_nao_encontrado': 'Parent category not found',
  'categoria.tipo_do_pai': 'The parent category has a different type: the child must have the same type',
  'categoria.tipo_invalido': 'Type must be revenue or expense',
  'centro_custo.duplicado': 'A cost center with this name already exists',
  'centro_custo.em_uso': 'The cost center has entries: deactivate it instead of removing',
  'centro_custo.inativo': 'The cost center is inactive',
  'centro_custo.nao_encontrado': 'Cost center not found',
  'centro_custo.nome_duplicado': 'A cost center with this name already exists',
  'certificado.curso_nao_concluido': 'The certificate is issued only after completing all lessons in the course',
  'certificado.nao_encontrado': 'Certificate code not found',
  'chave.escopo_invalido': 'Invalid scope',
  'chave.escopo_obrigatorio': 'Choose at least one scope',
  'chave.expirada': 'The key has expired; create a new one',
  'chave.invalida': 'Key with lowercase letters, numbers and underscores, starting with a letter (up to 41 characters)',
  'chave.ja_revogada': 'The key is already revoked',
  'chave.nao_encontrado': 'Key not found',
  'chave.papel_acima': 'This role has permissions you do not have',
  'chave.papel_dono': 'An API key cannot have the IT role. Use Administrator or a custom role.',
  'chave.papel_invalido': 'Role not found',
  'chave.somente_sessao': 'API keys can only be created and rotated by a logged-in user',
  'cliente.nao_encontrado': 'Customer not found',
  'cobranca.conflito': 'The charge is already being generated: wait a moment',
  'cobranca.documento_fechado': 'Only open or partially paid documents can be charged',
  'cobranca.envio_conflito': 'This charge was just sent through this channel: wait {{segundos}} s to send it again',
  'cobranca.limite_destino': 'This customer already received {{limite}} manual charges through this channel in the last 24 hours: wait before sending again',
  'cobranca.gerando_conflito': 'The Asaas charge is still being generated: wait a moment and send again, with the link',
  'cobranca.gerando_conflito_sicredi': 'The Sicredi Pix for this invoice is still being generated: wait a few minutes (up to 30) and send again, with the Pix',
  'sicredi.troca_limite': 'Automatic replacement stopped after 10 unpaid replacements',
  'sicredi.troca_falhou': 'The replacement of the expired Pix failed',
  'cobranca.whatsapp_indisponivel': 'WhatsApp is not available for this send: send by email',
  'cobranca.sem_email': 'The customer has no email on file',
  'cobranca.cliente_oculto': "This customer's contact belongs to another company you can't see: ask someone who sees that company to send the charge",
  'cobranca.sem_telefone': 'The customer has no mobile number on file',
  'cobranca.duplicada': 'This document already has a charge',
  'cobranca.forma_indisponivel': 'This customer\'s bank charges by Pix only: choose Pix',
  'cobranca.sem_provedor': 'The charging rule for this customer is "none": change it in Finance > Collections, on the customer record or on the contract',
  'sicredi.certificado_invalido': 'The Sicredi Pix certificate is not in PEM or could not be read',
  'sicredi.certificado_vencido': 'The Sicredi Pix certificate has expired: ask Sicredi for a new one and update the connector',
  'sicredi.chave_invalida': 'The Sicredi Pix private key does not match the certificate (or has a password)',
  'sicredi.recusado': 'Sicredi refused the request',
  'sicredi.url_invalida': 'The public server address must be HTTPS for Sicredi',
  'cobranca.parceiro_sem_documento': 'Add the customer\'s tax ID to generate the charge',
  'cobranca.tipo_invalido': 'Only invoices can be charged by Pix or bank slip',
  'codigo.invalido': 'Invalid code',
  'competencia.ano_mes_invalido': 'Enter the period as month/year.',
  'competencia.duplicada': 'Period {{competencia}} has already been opened.',
  'competencia.em_fechamento': 'This period is closing. Wait for it to finish.',
  'competencia.fechada': 'This period is already closed.',
  'competencia.fechamento_conflito': 'Closing this period is already in progress',
  'competencia.ja_aberta': 'Period {{competencia}} is already open.',
  'competencia.liquido_negativo': 'A payslip has a negative net amount. Review the deductions.',
  'competencia.nao_calculada': 'Calculate the period before continuing.',
  'competencia.nao_conferida': 'Review the period before closing it.',
  'competencia.nao_encontrado': 'Period not found',
  'competencia.nao_esta_fechando': 'The period is not being closed',
  'competencia.pessoas_indisponivel': 'The People module is not installed',
  'competencia.sem_funcionarios': 'There are no active employees to calculate this period.',
  'conciliacao.conflito_lancamento': 'This entry is already reconciled',
  'conciliacao.conflito_linha': 'This statement line is already reconciled',
  'conciliacao.conta_diferente': 'The entry is not from this statement\'s account',
  'conciliacao.lancamento_estornado': 'A reversed entry cannot be reconciled',
  'conciliacao.lancamento_nao_conciliado': 'This entry is not reconciled',
  'conciliacao.linha_nao_conciliada': 'This statement line is not reconciled',
  'conciliacao.valor_diferente': 'The entry amount does not match the statement line',
  'condicao_pagamento.invalida': 'Invalid payment terms: use avista, 30 or 30/60/90',
  'condicao_pagamento.parcelas_demais': 'Too many installments',
  'condicao_pagamento.prazo_longo': 'Each term must be up to 720 days',
  'conector.em_uso': 'There are open charges created by this company\'s own connector: receive or cancel them before switching back to the connector for all companies',
  'conector.campo_desconhecido': 'Unknown field for this connector',
  'conector.credencial_invalida': 'The connector key was rejected or belongs to another environment: check Integrations',
  'conector.ambiente_proibido': 'This workspace can only use the connector in sandbox or homologation (Sandbox workspace, staging or homologation): check it in Integrations',
  // Fase 2 (W30): WhatsApp com três provedores (pareamento e regras por provedor).
  'conector.modulo_conversas': 'Install the Conversations module to use WhatsApp',
  'conector.sem_pareamento': 'This connector is not paired by QR',
  'conector.whatsapp_outro_ativo': 'Another WhatsApp provider is connected in this workspace: disconnect it first',
  'conector.gateway_nao_configurado': 'This WhatsApp provider\'s gateway is not installed on this server',
  'conversas.whatsapp_sessao_antiga': 'Batch from a WhatsApp session that is not the current one in the workspace (from before a Disconnect or another pairing): ignored',
  'conector.gateway_fora': 'The WhatsApp gateway did not respond; try again in a moment',
  'conector.telefone_invalido': 'Enter the number with country and area code, digits only (e.g. 5511987654321)',
  'conector.sem_token_webhook': 'The workspace has no webhook token',
  // Review r20 security (M1): cap of unofficial WhatsApp numbers per account and a full server gateway.
  'conector.whatsapp_teto_conta': 'This account already has {{teto}} unofficial WhatsApp numbers paired or pairing (the maximum on this server). Disconnect the one in another workspace before pairing this one.',
  'conector.gateway_lotado': 'The WhatsApp server reached its limit of connected numbers; try again in a few minutes or contact support',
  // Review r20 robustez (B4) e spec (B1): motivos gravados no conector com o código (traduzidos na tela).
  'conector.whatsapp_banido': 'The number was blocked by WhatsApp',
  'conector.whatsapp_encerrada': 'The session was ended on the phone; pair again',
  'conector.whatsapp_pareamento_expirado': 'Pairing expired before the QR code was scanned; pair again',
  // W40: sinais do WhatsApp não oficial (bloqueio temporário, restrição 463, versão recusada, falha de conexão).
  'conector.whatsapp_banido_temporario': 'WhatsApp temporarily blocked the number; the connection comes back on its own when the block ends',
  'conector.whatsapp_restrito': 'WhatsApp restricted this number from starting chats; sending is paused until the restriction ends',
  'conector.whatsapp_versao': 'WhatsApp rejected the gateway version; contact Malgo IT to update it',
  'conector.whatsapp_falha_conexao': 'WhatsApp rejected the number\'s connection; use Pair to try again or contact Malgo IT',
  'conector.whatsapp_nao_pareado': 'The number is not paired yet: use the QR code or the pairing code',
  'conector.pareamento_cancelado': 'WhatsApp was disconnected while pairing was starting; pair again',
  'template.so_oficial': 'Approved templates only exist on the official WhatsApp API; with Baileys or whatsmeow, send free text',
  'conector.conflito': 'The connector credential changed during the test: test again',
  'conector.campo_invalido': 'Invalid value or format in this field',
  'conector.campo_longo': 'The value of this field is too long',
  'conector.campo_obrigatorio': 'Fill in this field',
  'conector.desconectado': 'The connector is not connected: connect it in Integrations',
  'conector.google_nao_configurado': 'The server has no Google credentials configured',
  'conector.nao_encontrado': 'Unknown connector',
  'conector.sem_credencial': 'Save the credential before testing',
  'conector.use_oauth': 'This connector connects through the Connect button',
  // Review r49 visual (B1): erros gravados do teste dos conectores, com código.
  'contaazul.renovado_em_paralelo': 'Another run renewed the access while the test was running: test again',
  'conector.gmail_sem_caixa': 'Enter at least one monitored mailbox',
  'conector.gmail_recusado': 'Gmail refused access to the mailbox: check the domain-wide delegation and the scopes',
  'conector.resposta_http': 'The provider responded with an error: try again in a moment or check the credential',
  'conector.rede': 'Network failure talking to the provider: try again in a moment',
  'conector.token_expirado': 'The connector token expired or was revoked: generate a new one and save the credential',
  'conector.graph_recusado': 'Meta\'s Graph API rejected the request: check the token and the ID',
  'conector.credencial_recusada': 'The provider rejected the credential: check the key and the environment in Integrations',
  'conector.credencial_incompleta': 'Incomplete credential: fill in all fields',
  'conector.certificado_formato': 'Certificate or private key is not in PEM format',
  'sicredi.cadeia_formato': 'The Sicredi certificate chain is not in PEM format: paste the complete chain again in Integrations',
  'sicredi.escopo_negado': 'Sicredi has not enabled all the scopes used (cob, cobv, pix and webhook) for this credential: ask your cooperative for the Immediate charge and Charge with due date modalities of the Pix API',
  'conector.campo_nao_removivel': 'This field cannot be cleared: replace its value',
  'conector.certificado_chave': 'The private key does not match the certificate',
  'conector.certificado_vencido': 'The certificate has expired: upload a valid certificate',
  'conector.certificado_ilegivel': 'The certificate or the private key could not be read (password-protected keys are not accepted)',
  'conector.ambiente_trocado': 'The key belongs to another environment: use the key for the chosen environment',
  'conector.imap_indisponivel': 'The IMAP/SMTP connector does not connect yet in this version; use Gmail',
  'google.expirado': 'Google access expired or was revoked: reconnect the account in Integrations',
  'google.renovacao_recusada': 'Google refused to renew the access: reconnect the account',
  'google.delegacao_negada': 'Google denied the domain-wide delegation: authorize the service account in the Workspace Admin',
  'google.token_recusado': 'Google refused the service account token request: check the key',
  'conflito.concorrencia': 'Another operation changed the same data at the same time. Try again.',
  'conta.duplicado': 'An account with this name already exists',
  'conta.em_uso': 'The account has entries or statements and cannot be changed this way: deactivate it instead of removing',
  'conta.inativa': 'The account is inactive',
  'conta.moeda_diferente': 'The account is in a different currency',
  'conta.nao_encontrado': 'Account not found',
  'conta.nome_duplicado': 'An account with this name already exists',
  'conta.padrao_inexistente': 'There is no default account: create one or choose an account',
  'conta.padrao_obrigatoria': 'Choose another account as the default first',
  'contato.invalido': 'Invalid contact',
  'contrato_tipo.invalido': 'Invalid contract type',
  'conversa.encerrada': 'A closed conversation cannot be transferred',
  'conversa.ja_encerrada': 'The conversation is already closed',
  'conversa.mesmo_atendente': 'The conversation is already with this agent',
  'caixa.invalida': 'Invalid mailbox',
  'conversa.janela_fechada': 'More than 24 hours since the contact last wrote: on WhatsApp, only an approved template',
  'conversa.janela_instagram': 'More than 7 days since the contact last wrote: Instagram no longer accepts a reply in this conversation',
  'conversa.sem_thread': 'Email conversation without the provider thread',
  'email.da_propria_caixa': 'Email sent by the mailbox itself',
  'fila.membro_invalido': 'Some member is not an active user of this workspace',
  'fila.nao_encontrado': 'Queue not found',
  'fila.nome_duplicado': 'A queue with this name already exists',
  'fila.funil_invalido': 'Pipeline not found or archived',
  // Trilha 5b (Conversas substitui o Digisac): etiquetas, horário da fila, menu de entrada e palavras-chave.
  'etiqueta.invalida': 'Each label has 1 to 30 characters, with no invisible characters',
  'etiqueta.muitas': 'At most 10 labels per conversation',
  'fila.em_uso': 'The queue is in the entry menu or in a keyword reply: remove it from there before deleting',
  'fila.horario_invalido': 'Check the hours: in each range the start comes before the end, ranges do not overlap and holidays are valid dates',
  'menu.nao_encontrado': 'This channel has no menu',
  'menu.conflito': 'This channel menu changed since you opened it: reopen it with the current version',
  'menu.tecla_invalida': 'Each option uses a number from 1 to 9',
  'menu.tecla_repetida': 'Two options use the same number',
  'palavra_chave.muitas': 'At most 20 words per rule',
  'palavra_chave.nao_encontrado': 'Rule not found',
  'palavra_chave.obrigatoria': 'Enter at least one word',
  'permissao.automacao_exige_todas': 'The menu and keywords apply to the whole workspace: only someone who sees all companies can change them',
  'google.conta_servico_invalida': 'Paste the service account key JSON as Google Cloud downloads it',
  'midia.canal_invalido': 'Instagram does not take attachments here',
  'midia.muito_grande': 'File too large for this channel',
  'midia.tipo_nao_permitido': 'File type not allowed',
  'midia.um_por_mensagem': 'In this channel (WhatsApp or Portal), send one file per message',
  'dispositivo.endpoint_em_uso': 'This device already receives notifications for another person; they need to turn it off first',
  'dispositivo.endpoint_invalido': 'This browser uses a push service the system does not accept',
  'dispositivo.nao_encontrado': 'Device not found',
  'notificacao.tipo_desconhecido': 'Unknown notification type',
  'conversa.nao_encontrado': 'Conversation not found',
  'convite.duplicado': 'There is already a pending invitation for this email',
  'convite.encerrado': 'This invitation was closed. If still needed, send a new invitation.',
  'convite.ja_aceito': 'This invitation was already accepted',
  'convite.nao_encontrado': 'Invitation not found or expired',
  'convite.exige_login': 'You already have an account: sign in with your e-mail or username to accept',
  'convite.outra_conta': 'This invitation is for another e-mail: sign in with the invited account to accept',
  'convite.membro_ativo': 'You already have access to this workspace',
  'convite.papel_dono': 'Invite with another role and promote to IT afterwards',
  'convite.reenvio_conflito': 'This invitation was just sent. Wait a minute before resending.',
  'convite.limite_hora': 'Hourly invitation limit reached ({{limite}}). Try again later.',
  'convite.limite_hora#convidar': 'Hourly invitation limit reached ({{limite}}). Hire without the invitation or try again later.',
  'cor.invalida': 'Invalid color',
  'corpo.obrigatorio': 'Enter the body or the id of a saved template',
  'cotacao.em_uso': 'The quote already became an order',
  'cotacao.escolhida': 'The chosen quote cannot be changed. Choose another one first',
  'cotacao.fornecedor_duplicado': 'This supplier already quoted this request. Edit the existing quote',
  'cotacao.item_fora_da_requisicao': 'The quote has a product that is not in the request',
  'cotacao.item_repetido': 'The same product appears in more than one item',
  'cotacao.itens_demais': 'Up to 200 items',
  'cotacao.nao_encontrado': 'Quote not found',
  'cotacao.prazo_invalido': 'The delivery time must be between 0 and 720 days',
  'cotacao.requisicao_estado_invalido': 'The request is not in a status that accepts quotes',
  'cotacao.requisicao_nao_aprovada': 'Only an approved request has a chosen quote',
  'cotacao.sem_itens': 'Add at least one item',
  'cotacao.vencida': 'The quote validity has expired',
  'cpf.invalido': 'Enter a valid tax ID (11 digits)',
  'curso.bloqueado': 'Complete the prerequisite course first',
  'curso.em_uso': 'This course has enrollments or dependents. Unpublish it instead of deleting.',
  'curso.grade_invalida': 'Send every module or lesson of the course, each one once',
  'curso.nao_encontrado': 'Course not found',
  'curso.nao_publicado': 'The course is not published yet',
  'curso.pre_requisito_ciclo': 'This prerequisite would create a loop between courses',
  'curso.pre_requisito_invalido': 'A course cannot be its own prerequisite',
  'curso.sem_aulas': 'A published course needs at least one lesson. Unpublish the course first',
  'curso.titulo_duplicado': 'A course with this title already exists',
  'cursor.invalido': 'Invalid cursor',
  'data.antes_da_admissao': 'The date cannot be before the hire date',
  'data.futura': 'The date cannot be in the future',
  'data.invalida': 'Invalid date: use YYYY-MM-DD or an ISO 8601 date and time between 1900 and 2100',
  'data_hora.invalida': 'Invalid date and time',
  'data_pagamento.invalida': 'Enter a valid payment date.',
  'departamento.ciclo': 'This would create a loop in the department tree',
  'departamento.em_uso': 'The department is in use by sub-departments, roles or employees',
  'departamento.nao_encontrado': 'Department not found',
  'departamento.nome_duplicado': 'A department with this name already exists',
  'departamento.gestor_divergente': 'The manager given in the old field must be the first in the list of managers',
  'departamento.gestores_demais': 'At most 10 managers per department',
  'departamento.gestor_repetido': 'The same person appears more than once among the managers',
  'departamento.pai_invalido': 'A department cannot be its own parent',
  'departamento.pai_nao_encontrado': 'Parent department not found',
  'deposito.em_uso': 'The warehouse has movements or inventories. Deactivate it instead of removing',
  'deposito.inativo': 'The warehouse is inactive',
  'deposito.nao_encontrado': 'Warehouse not found',
  'deposito.nome_duplicado': 'A warehouse with this name already exists',
  'deposito.padrao_obrigatorio': 'Choose another warehouse as the default first',
  'deposito.padrao_conflito': 'Another warehouse was set as the default at the same time. Try again.',
  'descricao.obrigatorio': 'Description is required',
  'digitos.invalido': 'Digits from 1 to 12',
  'dinheiro.invalido': 'Amount must be a whole number of cents',
  'dinheiro.moeda_invalida': 'Invalid currency',
  'documento.cancelado': 'A canceled document accepts no payment',
  'documento.cnpj_invalido': 'Enter a valid company tax ID (14 digits)',
  'documento.com_baixa': 'A document with payments cannot be canceled',
  'documento.conflito': 'A document with this number, or for this recurrence and date, already exists',
  'documento.cpf_invalido': 'Invalid tax ID',
  'documento.ein_invalido': 'Invalid EIN: 9 digits (00-0000000) with a prefix assigned by the IRS',
  'documento.ssn_invalido': 'Invalid SSN: 9 digits (000-00-0000), not starting with 000, 666 or 9xx',
  'documento.itin_invalido': 'Invalid ITIN: 9 digits starting with 9 (9XX-XX-XXXX)',
  'documento.cif_invalido': 'Invalid company NIF (CIF): a letter, 7 digits and the check character',
  'documento.nif_invalido': 'Invalid NIF: 8 digits and the check letter',
  'documento.nie_invalido': 'Invalid NIE: X, Y or Z, 7 digits and the check letter',
  'documento.tipo_obrigatorio': 'Choose the document type',
  'documento.tipo_longo': 'Document type up to 30 characters',
  'endereco.cep.muito_longo': 'Postal code up to {{max}} characters',
  'endereco.uf.muito_longo': 'State or province up to {{max}} characters',
  'endereco.zip_invalido': 'ZIP code with 5 or 9 digits (00000 or 00000-0000)',
  'endereco.estado_invalido': 'Choose one of the 50 US states or DC',
  'endereco.provincia_invalida': 'Choose a province of Spain',
  'endereco.codigo_postal_invalido': 'Spanish postal code with 5 digits (01000 to 52999)',
  'endereco.provincia_codigo_postal': 'The postal code does not belong to the selected province',
  'empresa.moeda_invalida': 'Company currency: BRL, USD or EUR',
  'cobranca.empresa_estrangeira': 'Pix, boleto and billing through Asaas or Sicredi are only for companies in Brazil: the company on this invoice is in another country',
  'ponto.empresa_estrangeira': 'The official time clock (REP-P, AFD and AEJ) follows Brazilian law and applies only to companies in Brazil',
  'documento.desconto_invalido': 'The discount must be lower than the document amount',
  'documento.invalido': 'Document must be a personal or company tax ID',
  'documento.itens_demais': 'Too many items in this document',
  'documento.ja_cancelado': 'The document is already canceled',
  'documento.ja_pago': 'The document is already paid',
  'documento.moeda_diferente': 'The amounts are in a currency other than the workspace currency',
  'documento.nao_encontrado': 'Document not found',
  'documento.parceiro_obrigatorio': 'Choose the customer or supplier',
  'documento.parcela_invalida': 'Invalid installment',
  'documento.parcelas_demais': 'The amount is too small for that many installments',
  'documento.sem_itens': 'Add at least one item',
  'documento.tipo_incompativel': 'The tax ID type does not match the partner type',
  'documento.tipo_invalido': 'Type must be invoice, payable, credit note or refund',
  'documento.valor_invalido': 'The document amount must be greater than zero',
  'documento.vencimento_anterior': 'The due date cannot be before the issue date',
  'duracao.invalida': 'The duration must be from 5 to 1440 minutes',
  'email.invalido': 'Invalid email',
  'empresa.consolidado_negado': 'You are not allowed to view all companies',
  'permissao.painel_grupo_exige_todas': 'The group dashboard is only for people who see all companies of the workspace',
  'empresa.divergente': 'The linked records belong to different companies',
  'empresa.sem_escopo': 'No company is available for this record: check the allowed companies',
  'empresa.obrigatoria': 'Choose the company for this record in the form (or filter one company at the top)',
  'membro.empresas_pela_ficha': "This person's companies are the verticals on their employee record: change them in People",
  'empresa.documento_duplicado': 'A company with this tax ID already exists in the same country',
  'assinaturas.dias_obrigatorio': 'Enter the number of days in advance',
  'conector.empresa_nao_suportado': 'This connector applies to all companies in the workspace',
  'conector.empresa_obrigatoria': 'Pick one company (top filter or the page\'s Company field) to set up the connector only for it',
  'permissao.todas_empresas': 'Only someone who sees all companies in the workspace can set up the all-companies connector',
  'empresa.nao_encontrado': 'Company not found in this workspace',
  'empresa.ultima_ativa': 'Keep at least one active company',
  // Fase 2, W2b: compartilhamento entre empresas.
  'permissao.dono': 'Only the workspace IT changes sharing between companies',
  'compartilhamento.distribuicao_obrigatoria': 'Choose where the group records go before separating by company',
  'compartilhamento.confirmacao_obrigatoria': 'Confirm the distribution of the records before saving',
  'compartilhamento.orfaos': 'The distribution would leave records without a company; nothing was changed',
  'compartilhamento.sem_empresa': 'Add at least one company before separating information by company',
  'entrada.grande_demais': 'Input has more than {{limite}} fields and items',
  'entrada.invalida': 'Check the highlighted fields',
  'entrada.lista_excedida': 'The list has too many items',
  'entrada.profundidade_excedida': 'Input is nested more than {{limite}} levels deep',
  'entrega.nao_encontrado': 'Delivery not found',
  'equipe.duplicada': 'A team with this name already exists',
  'equipe.em_uso': 'This team has open opportunities; move them to another team before deleting',
  'equipe.nao_encontrado': 'Team not found',
  'equipe.nome_duplicado': 'A team with this name already exists',
  'erro': 'Error',
  'erro.interno': 'Internal error. Try again in a moment.',
  'escala.dias_excedem': 'The schedule allows fewer working days per week',
  'escala.invalida': 'Schedule must be 5x2, 6x1 or 12x36',
  'escopo.negado': 'The key does not have the required scope',
  'estoque.lote_obrigatorio': 'This product tracks batches: enter the batch',
  'estoque.saldo_insuficiente': 'Not enough stock for this movement',
  'etapa.duplicada': 'A stage with this name already exists',
  'etapa.em_uso': 'There are opportunities in this stage; move them first',
  'etapa.ganha_inexistente': 'The pipeline has no won stage',
  'etapa.nao_encontrado': 'Stage not found',
  'etapa.nome_duplicado': 'A stage with this name already exists',
  'etapa.ordem_invalida': 'Send every stage, each one once',
  'etapa.perdida_inexistente': 'The pipeline has no lost stage',
  'etapa.tipo_obrigatorio': 'The pipeline must keep at least one stage of this type',
  'etapa.outro_funil': 'The stage belongs to another pipeline',
  'funil.arquivado': 'The pipeline is archived: unarchive it to create opportunities in it',
  'funil.duplicado': 'A pipeline with this name already exists',
  'funil.em_uso': 'The pipeline has open opportunities: close or delete them before archiving',
  'funil.nao_encontrado': 'Pipeline not found',
  'funil.nome_duplicado': 'A pipeline with this name already exists',
  'funil.padrao': 'The default pipeline cannot be archived: opportunities without a pipeline go there',
  'evento.codigo_duplicado': 'An event with this code already exists.',
  'evento.codigo_invalido': 'Use a short code with letters and numbers.',
  'evento.em_uso': 'This event was already used in a payroll and cannot be deleted.',
  'evento.especial_invalido': 'Invalid default event',
  'evento.forma_invalida': 'Invalid form',
  'evento.inativo': 'Inactive event',
  'evento.incidencia_invalida': 'Invalid incidence',
  'evento.incidencia_so_provento': 'Only earnings have incidences.',
  'evento.nao_encontrado': 'Event not found',
  'evento.nao_variavel': 'Only variable events accept entries',
  'evento.natureza_invalida': 'Invalid nature',
  'evento.padrao_protegido': 'Default event: only name, status and incidences can change.',
  'evento.percentual_invalido': 'Enter a valid percentage.',
  'evento.percentual_obrigatorio': 'Enter the event percentage.',
  'evento.tipo_invalido': 'Invalid type',
  'evento.valor_invalido': 'Enter an amount greater than zero.',
  'evento.valor_obrigatorio': 'Enter the event amount.',
  'eventos.demais': 'Too many events',
  'eventos.desconhecido': 'There is an event outside the catalog',
  'eventos.obrigatorio': 'Choose at least one event',
  'expira_em.invalido': 'Invalid expiration date: use YYYY-MM-DD or an ISO 8601 date and time, up to 2100',
  'expira_em.no_passado': 'The expiration must be in the future',
  'exportacao.periodo_invalido': 'The end of the period is before the start',
  'extras.invalido': 'Invalid custom fields',
  'extrato.vazio': 'The file is empty',
  'extrato_linha.nao_encontrado': 'Statement line not found',
  'fim.invalido': 'The end must be after the start',
  'fim_contrato.antes_da_admissao': 'Contract end is before the hire date',
  'financeiro.indisponivel': 'The Finance module is not available to record the payment entry',
  'fluxo.periodo_invalido': 'The end of the period is before the start',
  'fluxo.periodo_longo': 'The period is over the day limit',
  'folha.faixas_invalidas': 'The payroll bracket settings are invalid',
  'fornecedor.nao_encontrado': 'Supplier not found',
  'funcao.em_uso': 'There are employees in this role',
  'funcao.nao_encontrado': 'Role not found',
  'funcao.nome_duplicado': 'A role with this name already exists',
  'funcionario.cpf_duplicado_na_conta': 'This tax ID already exists in the account, in another workspace. If it is the same person, add the employment where they are registered',
  'funcionario.cpf_duplicado': 'An employee with this tax ID already exists',
  'funcionario.desligado': 'This employee has been terminated.',
  'funcionario.email_duplicado': 'This email already belongs to another employee',
  'funcionario.com_acesso': 'The person has access to the system: terminate instead of deleting',
  'funcionario.com_vinculos': 'The person has an employment link in another company: end the links or terminate instead of deleting',
  'funcionario.e_gestor': 'The person manages someone: change the manager before deleting',
  'funcionario.em_uso': 'The employee has records in other modules: terminate instead of deleting',
  'funcionario.gestor_invalido': 'An employee cannot be their own manager',
  'funcionario.ja_*': 'The employee is already in this status',
  'funcionario.nao_encontrado': 'Employee not found',
  'funcionario.nao_vinculado': 'Your user is not linked to an employee in People. Ask HR to add your email to your employee record.',
  'funcionario.proprio_acesso': 'You cannot remove your own access',
  'funcionario.transicao_invalida': 'The employee cannot change to this status',
  'gestor.nao_encontrado': 'Manager not found or already terminated',
  'google.nao_configurado': 'Google credentials are not configured',
  'google.rede': 'Could not reach Google',
  'google.troca_recusada': 'Google refused the authorization code',
  'habilidade.nao_encontrado': 'Skill not found',
  'habilidade.nivel_invalido': 'Level must be a whole number from 1 to 5',
  'habilidade.nome_duplicado': 'A skill with this name already exists',
  'holerite.nao_encontrado': 'Payslip not found',
  'horario.dia_invalido': 'Invalid weekday',
  'horario.hora_invalida': 'Use times in HH:MM format',
  'horario.intervalo_invalido': 'The end of the break must be after the start',
  'horario.invalido': 'Invalid working hours',
  'horario.sobreposto': 'Breaks on the same day cannot overlap',
  'horas.excedem_jornada': 'The hours for this day are over the limit',
  'horas.invalidas': 'Invalid hours (0 to 24, in multiples of 15 minutes)',
  'horas.vazia': 'Enter hours for at least one day',
  'idempotencia.conflito': 'This Idempotency-Key was already used with another request',
  'idempotencia.em_andamento': 'A request with this Idempotency-Key is still being processed',
  'idempotencia.obrigatoria': 'The Idempotency-Key header is required',
  'importacao.sem_nome': 'The CSV has no name column',
  'inicio.obrigatorio': 'Enter the new start',
  'inicio.invalido': 'Invalid start date and time',
  'inventario.conflito': 'This warehouse already has an open inventory',
  'inventario.fechado': 'This inventory is already closed',
  'inventario.nao_encontrado': 'Inventory not found',
  'inventario.sem_contagem': 'No item was counted. Record at least one count before closing',
  'item.categoria_incompativel': 'This item uses a category of another type',
  'item.quantidade_invalida': 'The item quantity must be greater than zero',
  'item.recorrencia_incompativel': "The item recurrence must be the contract's or a multiple of it (a one-off contract only takes one-off items)",
  'item.recorrencia_invalida': 'Invalid item recurrence',
  'item.valor_invalido': 'Invalid item unit amount',
  'job.nao_encontrado': 'Job not found',
  'job.recusado': 'Rejected by a business rule',
  'json.invalido': 'Invalid JSON',
  'justificativa.longa': 'The justification has at most 500 characters',
  'justificativa.obrigatoria': 'Write the justification (at least 10 characters)',
  'lancamento.baixa_recusada': 'Receivables refused to reverse this entry\'s payment',
  'lancamento.categoria_incompativel': 'The category type does not fit this entry',
  'lancamento.conflito_estorno': 'This entry was already reversed',
  'lancamento.conta_obrigatoria': 'Choose the account',
  'lancamento.destino_so_transferencia': 'Destination account only applies to transfers',
  'lancamento.estorno_data_anterior': 'The reversal date cannot be before the entry date',
  'lancamento.estorno_de_estorno': 'A reversal cannot be reversed: create a new entry if needed',
  'lancamento.ja_estornado': 'This entry was already reversed',
  'lancamento.moeda_diferente': 'The account currency differs from the entry currency',
  'lancamento.nao_encontrado': 'Entry not found',
  'lancamento.tipo_invalido': 'Type must be income, expense or transfer',
  'lancamento.valor_invalido': 'The entry amount must be greater than zero (the direction comes from the type)',
  'limite.excedido': 'Request limit per minute exceeded',
  'local.codigo_duplicado': 'A location with this code already exists in this warehouse',
  'local.em_uso': 'The location has recorded movements',
  'local.nao_encontrado': 'Location not found',
  'logo.invalida': 'Logo not found: upload the file for this company before linking it',
  'lote.codigo_duplicado': 'A batch with this code already exists for this product',
  'lote.em_uso': 'The batch has recorded movements',
  'lote.nao_encontrado': 'Batch not found',
  'material.nao_encontrado': 'Material not found in this lesson',
  'matricula.concluida': 'A completed enrollment cannot be canceled',
  'matricula.duplicada': 'This person is already enrolled in this course',
  'matricula.duplicado': 'This person is already enrolled in this course',
  'matricula.nao_encontrado': 'Enrollment not found',
  'matricula.necessaria': 'Enroll in the course to record lesson progress',
  'mcp.concorrencia': 'Limit of simultaneous calls per key reached',
  'mcp.timeout': 'The tool exceeded the time limit',
  'membro.auto_desativacao': 'You cannot deactivate yourself',
  'membro.duplicado': 'This person is already a member of the workspace',
  'membro.inativo': 'Deactivated member: reactivate them before promoting to IT or changing their access',
  'membro.ja_ativo': 'The member is already active',
  'membro.ja_dono': 'This member is already IT',
  'membro.ja_inativo': 'The member is already deactivated',
  'membro.remover_ativo': 'Deactivate the member before removing them from the workspace',
  'membro.auto_remocao': 'You cannot remove yourself',
  'membro.ja_removido': 'The member was already removed from the workspace',
  'membro.nao_encontrado': 'Member not found in this workspace',
  'membro.sem_papel': 'The member needs at least one role',
  'membro.ultimo_dono': 'The workspace needs at least one active IT member. Promote another member to IT first.',
  'membro.usar_promocao': 'To make someone IT, use the promote to IT action',
  'mensagem.duplicada': 'This message was already sent',
  'mensagem.muito_longa': 'The message is over {{max}} characters',
  'mensagem.sem_id_provedor': 'Message without a provider id',
  'mensagem.vazia': 'The message cannot be empty',
  'mes.invalido': 'Month must be in YYYY-MM format, between 1900 and 2100',
  'meta.alvo_invalido': 'A goal belongs to a team or to a salesperson, not both and not neither',
  'meta.duplicada': 'A goal for this target and month already exists',
  'meta.nao_encontrado': 'Goal not found',
  'modelo.codigo_duplicado': 'A template with this code already exists',
  'modelo.nao_encontrado': 'Template not found',
  'modulo.dependencia_desligada': 'First turn on, in this workspace, the module this one depends on',
  'modulo.dependente_instalado': 'This module cannot be uninstalled: another module depends on it. Uninstall the other one first.',
  'modulo.dependente_ligado': 'First turn off, in this workspace, the module that depends on this one',
  'modulo.em_uso': 'Lessons in other modules require lessons from this module. Remove those prerequisites first.',
  'modulo.fixo': 'This module is fixed and cannot be uninstalled',
  'modulo.nao_encontrado': 'Module not found',
  'modulo.nao_instalado': 'The module is not installed or not turned on in this workspace',
  'modulo.nao_liberado_por_workspace': 'This module applies to the whole tenant: install or uninstall it',
  'moeda.invalida': 'Invalid currency',
  'motivo_perda.duplicado': 'A reason with this name already exists',
  'motivo_perda.nao_encontrado': 'Loss reason not found',
  'motivo_perda.nome_duplicado': 'A loss reason with this name already exists',
  'motivo_perda.obrigatorio': 'Enter the loss reason',
  'movimentacao.deposito_obrigatorio': 'Enter the source warehouse',
  'movimentacao.destino_igual': 'Source and destination must be different warehouses',
  'movimentacao.destino_invalido': 'Only transfers have a destination warehouse',
  'movimentacao.destino_obrigatorio': 'Enter the destination warehouse',
  'movimentacao.motivo_obrigatorio': 'An adjustment requires a reason',
  'movimentacao.nao_encontrado': 'Movement not found',
  'movimentacao.sentido_invalido': 'Say whether the adjustment adds or subtracts',
  'movimentacao.tipo_invalido': 'Invalid movement type',
  'nascimento.invalido': 'Birth date must be before the hire date',
  'onboarding_item.nao_encontrado': 'Item not found',
  'opcoes.invalido': 'Up to 100 options of up to 80 characters each',
  'opcoes.obrigatorio': 'Add at least one option for the list field',
  'oportunidade.em_uso': 'The opportunity is in use and cannot be deleted',
  'chatter.mensagem_nao_encontrada': 'Note not found',
  'chatter.so_anotacao': 'Only notes and messages can be deleted; the history stays',
  'chatter.so_autor': 'Only the author can delete the note',
  'email.destinatarios_demais': 'Send to up to 20 addresses adding To, CC and BCC',
  'email_modelo.pronto': 'The CRM\'s ready-made template cannot be changed: use it as a base to create yours',
  'tratamento.invalido': 'Form of address must be Mr., Ms. or neutral',
  'sexo.invalido': 'Sex must be male, female or not informed',
  'telefone_tipo.invalido': 'Invalid phone type',
  'anexo.sem_previa': 'This file type has no preview: download the file',
  'email_modelo.demais': 'Up to 500 email templates per workspace',
  'email_modelo.nao_encontrado': 'Email template not found',
  'email_modelo.so_autor': 'Only the creator can stop sharing the template',
  'etapa.aberta_inexistente': 'The pipeline has no open stage to reopen the deal in',
  'oportunidade.aberta': 'The deal is already in progress',
  'oportunidade.contrato_vivo': 'The sale created an active contract in Subscriptions: end the contract before reopening the deal',
  'oportunidade.fechamento_futuro': 'The closing date cannot be in the future',
  'oportunidade.fechamento_antes_da_criacao': 'The closing date cannot be before the deal was created',
  'oportunidade.ganha': 'A won opportunity is not deleted: it created a project and counts toward goals',
  'oportunidade.encerrada': 'The opportunity is already closed',
  'oportunidade.pausada': 'The deal is paused: resume it before changing it',
  'motivo_pausa.obrigatorio': 'Enter the reason (at least 3 characters)',
  'motivo_pausa.muito_longo': 'The reason is longer than 500 characters',
  'oportunidade.etapa_final': 'This stage change is not allowed for the opportunity',
  'oportunidade.etapa_invalida': 'The chosen stage does not match the outcome',
  'oportunidade.mesma_etapa': 'The opportunity is already in this stage',
  'oportunidade.nao_encontrado': 'Opportunity not found',
  'oportunidade.recusada': 'The opportunity was refused',
  'orcamento.invalido': 'Invalid budget',
  'ordem.invalida': 'Invalid order (0 to 10000)',
  'origem.invalida': 'Invalid origin',
  'papel.de_fabrica_imutavel': 'Built-in roles cannot be changed. Create a custom role.',
  'papel.dono_por_atribuicao': 'The IT role is granted only by promotion in Admin',
  'papel.duplicado': 'A role with this name already exists',
  'papel.codigo_duplicado': 'Another role with the same internal code was created at the same time. Try again.',
  'papel.em_uso': 'The role is in use ({{usos}} members or pending invitations). Change their role before deleting.',
  'papel.nao_encontrado': 'Role not found',
  'papel.permissao_desconhecida': 'Some permission does not exist in the installed modules',
  'parceiro.arquivado': 'An archived partner cannot be edited or merged',
  'parceiro.documento_duplicado': 'A partner with this tax ID already exists',
  'parceiro.codigo_duplicado': 'A partner with this code already exists',
  'base_legal.invalida': 'Invalid legal basis',
  'em_massa.confirmacao': 'Type the number of records to confirm',
  'em_massa.valor': 'Choose a value for the action',
  'meu_horario.sem_usuario': 'Only a signed-in person has their own working hours',
  'parceiro.responsavel_invalido': 'The owner must be an active workspace user',
  'parceiro.seguidor_invalido': 'The follower must be an active workspace user',
  'parceiro.seguidor_sem_acesso': 'The follower cannot access this record (Records, company or vertical)',
  'parceiro.codigo_longo': 'Code with up to 30 characters',
  'parceiro.codigo_invalido': 'Code with an invalid character',
  'parceiro.em_uso': 'The partner has open invoices, purchase orders, recurrences or opportunities in other modules. Close or adjust them before archiving',
  'parceiro.indisponivel': 'Registry is not available to create the contact',
  'parceiro.ja_arquivado': 'The partner is already archived',
  'parceiro.mescla_conflito': 'This partner was already merged into another record',
  'parceiro.mescla_invalida': 'These partners cannot be merged',
  'parceiro.mesclado': 'This partner was already merged into another record',
  'parceiro.nao_encontrado': 'Partner not found',
  'parceiro.parent_invalido': 'This contact link is not allowed',
  'parceiro.empresas_limite': 'A contact can have at most 20 additional companies',
  'parceiro.empresa_principal': 'This is the contact\'s main company: change the main company before removing it',
  'parceiro.contato_invalido': 'Only a contact (person) can have linked companies',
  'parceiro.filial_invalida': 'A company cannot be a branch of itself',
  'parceiro.matriz_invalida': 'Only a company can have branches',
  'parceiro.filial_nao_encontrada': 'Branch not found',
  'parceiro.filial_com_matriz': 'This company is already a branch of another head office',
  'parceiro.matriz_e_filial': 'This company is a branch and cannot have branches',
  'parceiro.filial_e_matriz': 'This company has branches and cannot be a branch',
  'parceiro.filiais_limite': 'A head office can have at most 200 branches',
  'parceiro.tipo_com_filiais': 'This company is a branch or has branches: remove the link before changing the type',
  'parceiro.parent_nao_encontrado': 'Linked company not found',
  'pedido.com_recebimento': 'An order with receipts cannot be canceled',
  'pedido.conflito': 'An order with this number already exists',
  'pedido.cotacao_nao_escolhida': 'Only the chosen quote becomes an order',
  'pedido.estado_invalido': 'The order is not in a status that allows this action',
  'pedido.item_repetido': 'The same product appears in more than one item',
  'pedido.itens_demais': 'Up to 200 items',
  'pedido.nao_encontrado': 'Order not found',
  'pedido.requisicao_estado_invalido': 'The request must be approved and have no order yet',
  'pedido.sem_itens': 'Add at least one item',
  'periodo.invalido': 'The last day must be on or after the first',
  'periodo.longo': 'Period too long: choose up to two years',
  'periodo.muito_longo': 'Query a shorter period at a time',
  'valor.faixa_invalida': 'The minimum amount must be less than or equal to the maximum',
  'permissao.empresas_fora_do_alcance': 'You can only grant or remove companies you can see, and the list cannot be empty (empty grants all companies)',
  'permissao.convite_sem_empresa': 'You cannot see any company to give the invitee: invite without access or ask someone who sees the companies',
  'permissao.convite_empresas_fora': 'This invitation gives access to companies you cannot see: only someone who sees them can resend it',
  'permissao.empresas_exige_todas': 'Only someone who sees all companies in the workspace can add or archive a group company',
  'permissao.padrao_workspace_exige_todas': 'Only someone who sees all companies in the workspace can change the workspace default; choose your company',
  'permissao.vertical_todas': 'Only someone who sees all companies can mark or unmark "All"',
  'permissao.vertical_fora': 'You can only add or remove the business units you can see',
  'item.vertical_fora': 'The item business unit must be one of the opportunity business units',
  'item.vertical_obrigatoria': 'Choose the item business unit: the opportunity has more than one',
  'item.servico_fora_da_vertical': 'The service is not offered in the item business unit',
  'vertical.invalida': 'Business unit outside the companies of this workspace',
  'vertical.vazia': 'The record must stay in at least one business unit or in "All"',
  'verticais.amarradas': 'The business unit cannot be removed while there are active records linked to it in that company. Close or adjust those records first',
  'vertical.lote_grande': 'Mark up to 500 records at a time',
  'vertical.entidade_invalida': 'This record has no business units',
  'permissao.sequencia_exige_todas': 'Only someone who sees all companies in the workspace can create or edit the workspace sequence (no company)',
  'permissao.excede_ator': 'You cannot grant permissions you do not have',
  'permissao.excede_ator#paginas': 'You cannot grant pages you cannot open: {{paginas}}',
  'permissao.excede_ator#paginas_outro_workspace': 'The role is in use in another workspace where you cannot open these pages: {{paginas}}',
  'cadastro_previo.membro_invalido': 'Choose an active member of the workspace',
  'cadastro_previo.membro_sem_acesso': 'Choose someone who can edit People (Employees): the notice and the card only go to who can complete the record',
  'permissao.pagina_negada': 'Your access does not include this page',
  'papel.pagina_desconhecida': 'Some page does not exist in the installed modules',
  'membro.dono_sem_excecao': 'IT has access to everything: there is no exception to make',
  'acesso.codigo_invalido': 'Invalid action or page code',
  'acesso.codigo_desconhecido': 'Some action or page does not exist in the installed modules',
  'permissao.lancamento_proprio': 'You cannot enter or remove a variable on your own payroll. Ask someone else with payroll access',
  'permissao.negada': 'You do not have permission for this action',
  'permissao.plataforma': 'Only the platform administrator can access this area',
  'historico_telas.nao_encontrado': 'Image not found in the screen history',
  'tela_entrada.grande': 'Image larger than 5 MB. Use the adjustment tool or upload a smaller file',
  'tela_entrada.formato': 'Upload a PNG, JPG or WebP image (SVG and other formats are not accepted)',
  'tela_entrada.pequena': 'Image too small (minimum {{largura}} × {{altura}} px)',
  // Lista de 30/10 (itens 6 e 11): foto do perfil e pedidos de troca de acesso.
  'avatar.formato': 'Send a PNG, JPG or WebP photo',
  'avatar.grande': 'Photo larger than 2 MB',
  'avatar.invalida': 'This photo could not be read; send another PNG, JPG or WebP file',
  'avatar.nao_encontrado': 'Photo not found',
  'avatar.pequena': 'Photo too small (minimum {{minimo}} × {{minimo}} px)',
  'avatar.pixels': 'Photo too large (over 50 megapixels); reduce it before sending',
  'avatar.prazo': 'Processing the photo took too long; send a smaller photo',
  'avatar.ocupado': 'Too many photos being processed right now. Try again in a moment',
  'avatar.processador_indisponivel': 'Image processing is not available on the server right now',
  'pedido_acesso.ja_decidido': 'This request has already been decided or canceled',
  'pedido_acesso.limite': 'Too many requests in the last hour: wait before asking again',
  'pedido_acesso.nao_encontrado': 'Request not found',
  'pedido_acesso.proprio': 'Another administrator needs to decide your request',
  'pedido_acesso.sem_decisor': 'Nobody here can decide your request because your account also belongs to another workspace: ask the platform administrator for the change',
  'usuario.mesmo': 'This is already your username',
  'tela_entrada.invalida': 'This image could not be read; upload another PNG, JPG or WebP file',
  'tela_entrada.ocupada': 'Too many images being processed right now. Try again in a moment',
  'tela_entrada.processador_indisponivel': 'Image processing is not available on the server right now. Try again in a moment',
  'tela_entrada.pixels': 'Image too large (over {{megapixels}} megapixels). Reduce it before uploading or use the adjustment tool',
  'tela_entrada.prazo': 'Processing the image took too long. Upload a smaller image or use the adjustment tool',
  'tela_entrada.nao_encontrado': 'Image not found',
  'uso_ia.chave_ampla': 'The meter key must have only the Admin panel: write scope and a role with only "Admin panel: view"',
  'permissao.origem_invalida': 'Request origin not allowed',
  'permissao.so_sessao': 'This action belongs to the person: only with a user session, not an API key',
  'permissao.salario_confidencial': 'Salary is confidential: only people with the salary and documents permission can set or change it',
  'permissao.salario_proprio': 'Nobody can change their own salary. Ask someone else with salary access',
  'permissao.mfa_reset_outro_workspace': 'This person is IT or Administrator in another workspace: only they, or IT there, can reset two-step verification',
  'permissao.somente_dono': 'Only IT can change IT\'s access',
  'pessoas.indisponivel': 'The People module is not installed',
  'pipeline.indisponivel': 'Install the Pipeline module to open opportunities',
  'posicao.invalida': 'Invalid position in seconds',
  'prazo.antes_do_inicio': 'Deadline before the start',
  'prazo_entrega.invalido': 'The delivery time must be between 0 and 365 days',
  'preco.invalido': 'Invalid price',
  'prefixo.invalido': 'The prefix accepts up to 30 characters and only the {ano} marker',
  'probabilidade.invalida': 'Probability must be a whole number from 0 to 100',
  'produto.codigo_duplicado': 'A product with this code already exists',
  'produto.em_uso': 'The product still has stock. Zero the balance before deleting',
  'produto.inativo': 'The product is inactive',
  'produto.nao_encontrado': 'Product not found',
  'projeto.cancelado': 'A canceled project cannot be edited',
  'projeto.indisponivel': 'Registry is not available to create the project',
  'projeto.nao_criado': 'Could not create the project',
  'projeto.nao_encontrado': 'Project not found',
  'projeto.status_igual': 'The project is already in this status',
  'projeto.transicao_invalida': 'The project cannot change to this status',
  'proximo.excede_digitos': 'The number does not fit in the chosen digits',
  'proximo.invalido': 'The next number starts at 1',
  'quantidade.invalida': 'Invalid quantity',
  'recebimento.acima_do_pedido': 'The receipt is above the order quantity',
  'recebimento.conflito': 'A receipt with this id or number already exists',
  'recebimento.contas_indisponivel': 'The Accounts module is not installed: there is nowhere to record the payable',
  'recebimento.contas_recusou': 'Accounts refused the payable',
  'recebimento.data_futura': 'The receipt date cannot be in the future',
  'recebimento.divergencia_sem_observacao': 'Describe the discrepancy on the unchecked item',
  'recebimento.estoque_indisponivel': 'The Stock module is not installed: there is nowhere to receive the goods',
  'recebimento.estoque_recusou': 'Stock refused the entry',
  'recebimento.item_invalido': 'The item does not belong to this order',
  'recebimento.item_repetido': 'The same order item appears more than once',
  'recebimento.lote_obrigatorio': 'Enter the batch code along with the expiry date',
  'recebimento.nao_encontrado': 'Receipt not found',
  'recebimento.sem_itens': 'Add at least one received item',
  'recorrencia.conflito': 'Recurrence is being processed by the automatic issuing. Try again in a moment.',
  'recorrencia.data_final_invalida': 'Invalid recurrence end date',
  'recorrencia.fim_anterior': 'The recurrence end cannot be before the next issue date',
  'recorrencia.invalida': 'Invalid recurrence frequency',
  'recorrencia.muito_longa': 'The series is over the occurrence limit; shorten the end date',
  'recorrencia.nao_encontrado': 'Recurrence not found',
  'recurso.em_uso': 'The resource has upcoming appointments. Cancel or reschedule them before archiving',
  'recurso.erro': 'Could not use the resource',
  'recurso.inativo': 'The resource is inactive',
  'recurso.nao_encontrado': 'Resource not found',
  'recurso.usuario_so_profissional': 'Only a professional can be linked to a user',
  'regua.sem_dias': 'Enter at least one day in the collection schedule; to stop sending, turn the schedule off',
  'registro.duplicado': 'Duplicate record',
  'registro.invalido': 'Invalid value',
  'registro.nao_encontrado': 'Record not found',
  'registro.referencia_invalida': 'Invalid reference or from another scope',
  'requisicao.conflito': 'A request with this number already exists',
  'requisicao.em_uso': 'The request has linked quotes or orders',
  'requisicao.estado_invalido': 'The request is not in a status that allows this action',
  'requisicao.invalida': 'Invalid request',
  'requisicao.item_repetido': 'The same product appears in more than one item',
  'requisicao.itens_demais': 'Up to 200 items',
  'requisicao.nao_encontrado': 'Request not found',
  'requisicao.sem_itens': 'Add at least one item',
  'resposta.nao_encontrado': 'Quick reply not found',
  'resposta_rapida.atalho_duplicado': 'A quick reply with this shortcut already exists',
  'rota.nao_encontrado': 'Route not found',
  'salario.invalido': 'Invalid salary (whole cents, zero or more)',
  'senha.obrigatoria': 'Set a password',
  'sequencia.codigo_duplicado': 'A sequence with this code already exists for the company',
  'sequencia.digitos_menor_que_emitido': 'Issued numbers already have more digits than this',
  'sequencia.nao_encontrado': 'Sequence not found',
  'sequencia.proximo_menor': 'The next number cannot go backwards',
  'servico.em_uso': 'The service has upcoming appointments. Cancel or reschedule them before archiving',
  'servico.inativo': 'The service is inactive',
  'servico.indisponivel': 'Service temporarily unavailable. Try again in a moment.',
  'servico.nao_encontrado': 'Service not found',
  'servico.ocupado': 'The operation took too long. Try again in a moment.',
  'servico.recurso_nao_permitido': 'This service is not provided by this resource',
  'setor.nao_encontrado': 'Sector not found',
  'setor.nome_duplicado': 'A sector with this name already exists',
  'sku.invalido': 'The SKU cannot contain spaces',
  'slug.invalido': 'Use lowercase letters, numbers and hyphens in the identifier',
  'tag.nao_encontrado': 'Tag not found',
  'tag.nome_duplicado': 'A tag with this name already exists',
  'telefone.invalido': 'Invalid phone number',
  'template.canal_invalido': 'Templates exist only on WhatsApp',
  'template.duplicado': 'A template with this name and language already exists',
  'template.nao_aprovado': 'The template is not approved by Meta',
  'template.nao_encontrado': 'Template not found',
  'template.obrigatorio': 'Choose the template',
  'template.sem_corpo': 'The template has no body',
  'template.variaveis_invalidas': 'The template variables do not match what it expects',
  'template.amostra_tipo': 'The sample file does not match the header type',
  'template.autenticacao_botao': 'An authentication template only has the "Copy code" button',
  'template.autenticacao_cabecalho': 'An authentication template has no header',
  'template.botao_parametro': 'Fill in the parameter of each template button (link ending or code)',
  'template.botao_sobra': 'A template button does not take this kind of parameter',
  'template.botao_tipo': 'Invalid button type',
  'template.botoes_agrupados': 'Keep quick replies together, before or after the other buttons',
  'template.botoes_demais': 'Up to 10 buttons',
  'template.cabecalho_amostra': 'Upload a sample file for the header (Meta asks for it in the review)',
  'template.cabecalho_linha': 'The header has a single line',
  'template.cabecalho_midia': 'Fill in the https link of the template header media',
  'template.cabecalho_sobra': 'The template has no header with a parameter',
  'template.cabecalho_tamanho': 'Header up to 60 characters',
  'template.cabecalho_tipo': 'Invalid header type',
  'template.cabecalho_variavel': 'Fill in the template header variable',
  'template.cabecalho_vazio': 'Fill in the header text',
  'template.campos_fixos': 'Once sent to Meta, name, language and category cannot change: create another template',
  'template.categoria': 'Choose the category',
  'template.codigo': 'Code example with letters and numbers, up to 15',
  'template.copiar_demais': 'Up to 1 "Copy code" button',
  'template.corpo_tamanho': 'Body up to 1024 characters',
  'template.corpo_vazio': 'Fill in the body text',
  'template.edicao_diaria': 'Meta accepts one edit per day on an approved template: try again tomorrow',
  'template.enviando': 'The template is being sent for review: wait for the result',
  'template.exemplo_obrigatorio': 'Fill in an example for each variable',
  'template.exemplo_tamanho': 'The variable example is a single line up to 200 characters',
  'template.exemplo_url': 'Fill in an example of the link ending, without spaces',
  'template.expiracao': 'Code validity from 1 to 90 minutes',
  'template.idioma': 'Language in Meta format (pt_BR, en_US, es)',
  'template.limite_hora': 'Meta accepts up to 100 templates per hour: try again shortly',
  'template.links_demais': 'Up to 2 link buttons',
  'template.nao_editavel': 'Only approved, rejected or paused templates can be edited (this one is under review at Meta)',
  'template.nao_reenviavel': 'Only rejected or paused templates go back to review without editing',
  'template.nome': 'Name with lowercase letters, numbers and _, starting with a letter',
  'template.nome_existente': 'A template with this name and language already exists',
  'template.respostas_demais': 'Up to 10 quick replies',
  'template.rodape_linha': 'The footer has a single line',
  'template.rodape_tamanho': 'Footer up to 60 characters',
  'template.rodape_variavel': 'The footer takes no variable',
  'template.rotulo': 'Button label from 1 to 25 characters',
  'template.rotulo_repetido': 'Two buttons with the same label',
  'template.rotulo_variavel': 'The button label takes no variable',
  'template.telefone': 'Phone with country code, numbers only (e.g. +5511999999999)',
  'template.telefones_demais': 'Up to 1 phone button',
  'template.url': 'https:// link, with at most one variable at the end',
  'template.variaveis_demais': 'Up to one variable in the header',
  'template.variaveis_misturadas': 'Use only numbers or only names in the variables',
  'template.variaveis_sequencia': 'Numbered variables start at 1 and go on without skipping',
  'template.variavel_borda': 'The body cannot start or end with a variable',
  'template.variavel_invalida': 'Variable out of format: use numbers or names with lowercase letters, numbers and _',
  'tenant.nao_encontrado': 'Tenant not found',
  'tipo.invalido': 'Invalid type',
  'tool.nao_encontrado': 'Tool not found among the installed modules',
  'transferencia.destino_obrigatorio': 'Enter the destination account',
  'transferencia.mesma_conta': 'Source and destination must be different accounts',
  'transferencia.moeda_diferente': 'Cannot transfer between different currencies without an exchange rate',
  'transferencia.sem_categoria': 'A transfer has no category',
  'trilha.curso_repetido': 'A course appears more than once in the path',
  'trilha.nao_encontrado': 'Learning path not found',
  'trilha.nome_duplicado': 'A learning path with this name already exists',
  'unidade.invalida': 'Unit of measure not found',
  'url.interna': 'The URL points to the internal network',
  'url.invalida': 'Invalid URL',
  'url.muito_longo': 'URL too long',
  'url.obrigatorio': 'Enter the destination URL',
  'validade.antes_da_fabricacao': 'The expiry date cannot be before the manufacturing date',
  'valor.duplicado': 'This attribute already has a value with this name',
  'valor.em_uso': 'Some variations use this value',
  'valor.invalido': 'Invalid value: use whole cents',
  'valor.nao_encontrado': 'Value not found',
  'variacao.combinacao_duplicada': 'This product already has a variation with this combination of values',
  'variacao.duplicada': 'A variation with this combination already exists',
  'variacao.em_uso': 'The variation has movements. Deactivate it instead of removing',
  'variacao.nao_encontrado': 'Variation not found',
  'variacao.sem_combinacao': 'Choose at least one attribute value for the variation',
  'variacao.sku_duplicado': 'A variation with this SKU already exists',
  'variacao.valor_invalido': 'Some value does not exist or does not belong to the chosen attribute',
  'variavel.nao_encontrado': 'Entry not found',
  'visao.limite': 'Limit of {{max}} saved views reached. Remove one before saving another.',
  'visao.nao_encontrado': 'View not found',
  'visao.padrao_conflito': 'Another default view for this screen was saved at the same time. Try again.',
  'visao.papel_invalido': 'Role not found',
  'visao.pessoa_invalida': 'Person not found among the workspace members',
  'visao.sem_papeis': 'Choose at least one role',
  'visao.sem_pessoas': 'Choose at least one person',
  'webhook.assinatura_invalida': 'Invalid signature',
  'webhook.conector_desconectado': 'The connector is disconnected in this workspace: the event was not accepted',
  'webhook.estado_invalido': 'The subscription is not in a status that allows this action',
  'webhook.nao_encontrado': 'Subscription not found',
  'webhook.sem_evento': 'Add the event to this subscription to test it',
  'webhook.eventos_orfaos': 'There is an event from an uninstalled module: remove it from the subscription before changing the URL or reactivating. Its delivery is not resent',
  'webhook.verificacao_falhou': 'Verification refused',
  // Fase 2 (W8): modo de operação e compra direta.
  'compra.classificacao_por_item': 'With items, the category and cost center go on each item',
  // Fase 2 (W16): deleting a direct purchase and the Purchasing trash.
  'compra.em_uso': 'The purchase still has a live payable in Accounts: reverse the payment and cancel the payable before deleting',
  'compra.estado_invalido': 'Only a cancelled purchase can be deleted: cancel it first',
  'pedido.cotacao_ja_convertida': 'Another order was already created from the same quote: this one cannot come back',
  'compra.competencia_obrigatoria': 'Enter the accrual period',
  'compra.conflito': 'Another purchase with this number was recorded at the same time. Try again.',
  'compra.contas_indisponivel': 'The Receivables and payables module is not installed: there is nowhere to post the payable',
  'compra.descricao_obrigatoria': 'Describe the purchase',
  'compra.estoque_indisponivel': 'Inventory is not installed: describe the item without a product',
  'compra.tipo_divergente': 'The purchase type does not match the items: a service has no product and a product has no service',
  'compra.estoque_recusou': 'Inventory refused the entry of the purchased product',
  'ncm.invalido': 'The NCM has 8 digits (e.g. 8471.30.19)',
  'cest.invalido': 'The CEST has 7 digits (e.g. 21.106.00)',
  'valor_referencia_centavos.invalido': 'Invalid reference price',
  'compra.ja_cancelada': 'The purchase is already cancelled',
  'compra.nao_encontrado': 'Purchase not found',
  'compra.parcelas_demais': 'The amount is too small for that many installments',
  'compra.parcelas_invalidas': 'From 1 to 120 monthly installments',
  'compra.sem_valor': 'Enter the items or the purchase total',
  'compra.servico_indisponivel': 'The service catalog is not available yet: describe the item without a service',
  'compra.total_divergente': 'The total entered does not match the sum of the items',
  'compra.total_invalido': 'The purchase total must be greater than zero',
  'compra.vencimento_antes_competencia': 'The first due date must be on or after the accrual period',
  'compra.vencimento_obrigatorio': 'Enter the first due date',
  'grupo.invalido': 'Invalid installment group',
  'item.descricao_longa': 'Item description up to 300 characters',
  'item.descricao_obrigatoria': 'Describe the item',
  'subsistemas.confirmar_sem_lugar': '{{quantidade}} page(s) will no longer appear in the menus. Confirm to save (the data stays stored)',
  'subsistemas.link_invalido': 'Invalid link address: use an https:// address',
  'subsistemas.link_codigo_reservado': 'The code {{codigo}} belongs to a system subsystem; choose another',
  'subsistemas.link_nao_embutivel': 'This link cannot open inside MalgoOS (only allowed addresses, such as the password vault, and never the /admin panel). Uncheck "Open inside MalgoOS"',
  'subsistemas.link_duplicado': 'Two links have the same code',
  'modo.desconhecido': 'Unknown operating mode or module not installed',
  'modo.em_uso': 'There is work in progress that prevents changing the mode',
  'modo.indisponivel': 'This action is not available in the current operating mode. Change it in Settings > Operating mode.',
  'modo.opcao_invalida': 'Invalid mode option',
  'nf.chave_invalida': 'The access key has 44 digits',
  'nf.numero_longo': 'Invoice number up to 40 characters',
  'nf.serie_longa': 'Invoice series up to 10 characters',
  'referencia_externa.invalida': 'Invalid external reference',
  'workspace.nao_encontrado': 'Workspace not found',
  // Item 5 (21/10): exclusão de Plataforma, Workspace e Empresa.
  'exclusao.nome_nao_confere': 'Type the name exactly as shown to confirm',
  'empresa.destino_invalido': 'Choose another active company as the destination',
  'empresa.transferencia_conflito': 'The destination company already has a record with the same code, name or document; resolve it before transferring',
  'tenant.proprio': 'You cannot delete your own tenant',
  'workspace.em_uso': 'Switch to another workspace to delete this one',
  'workspace.slug_duplicado': 'A workspace with this identifier already exists',
  'workspace.ultimo_producao': 'The tenant needs at least one non-sandbox workspace',
  'aparencia.arquivo_duplicado': 'This file was already uploaded',
  'aparencia.arquivo_em_uso': 'This file is in use by the workspace appearance. Change it before removing',
  'aparencia.arquivo_nao_encontrado': 'File not found',
  'auth.codigo_invalido': 'Incorrect or already used code',
  'auth.desafio_invalido': 'The time to enter the code ran out. Sign in again with email and password',
  'auth.mfa_configuracao_obrigatoria': 'Set up two-step verification to continue',
  'fonte.formato_invalido': 'Upload a woff2, woff, ttf or otf font file',
  'fonte.grande_demais': '{{formato}} file over {{limite_kb}} KB',
  'fonte.invalida': 'Invalid font or not available in this workspace',
  'fonte.licenca_obrigatoria': 'Confirm that you have a web use license for this font',
  'fonte.limite': 'At most {{limite}} uploaded fonts. Remove one first',
  'fonte.pessoal_desativada': 'The administrator has not allowed a personal font choice',
  'aparencia.estilo_invalido': 'Invalid interface style',
  'estilo.fixado_pelo_admin': 'The administrator fixed the style of your account',
  'estilo.pessoal_desativado': 'The administrator has not allowed a personal style choice',
  'fonte.uso_web_proibido': 'The author of this font forbids its use on web pages (restricted license)',
  'logo.formato_invalido': 'Upload the logo as PNG or WebP (SVG is not accepted)',
  'logo.grande_demais': 'Logo over {{limite_kb}} KB',
  'mfa.codigo_invalido': 'Incorrect or already used code',
  'mfa.codigo_obrigatorio': 'Enter a code from your current app',
  'mfa.conflito': 'The setup changed in another window. Generate the QR code again',
  'mfa.qr_substituido': 'This code is from an old QR code, generated earlier in another window. Scan the QR code on the screen now',
  'mfa.inativo': 'Two-step verification is not on',
  'mfa.obrigatorio': 'Your role requires two-step verification. Switch devices instead of turning it off',
  'mfa.reset_proprio': 'For your own access, use My account, Security tab',
  'mfa.sem_configuracao': 'Generate the QR code again before turning it on',
  'senha.atual_incorreta': 'The current password does not match',
  'senha.curta': 'The new password needs at least 10 characters',
  'senha.igual_atual': 'The new password must be different from the current one',
  'sessao.nao_encontrada': 'Session not found or already ended',
  // Phase 2 (W6): Records catalogs and the import framework.
  'codigo.obrigatorio': 'Enter the code',
  'condicao_pagamento.codigo_duplicado': 'A payment term with this code already exists',
  'condicao_pagamento.em_uso': 'The payment term is in use',
  'condicao_pagamento.nao_encontrado': 'Payment term not found',
  'forma_pagamento.em_uso': 'The payment method is in use',
  'forma_pagamento.inativa': 'The payment method is inactive',
  'forma_pagamento.nao_encontrado': 'Payment method not found',
  'forma_pagamento.nome_duplicado': 'A payment method with this type and short name already exists: use another short name',
  'forma_pagamento.tipo_invalido': 'Choose a type from the list',
  'importacao.colunas_ausentes': 'The file is missing required columns. Download the template to see the right header',
  'importacao.linha_recusada': 'Row rejected: value out of range or duplicate record',
  'importacao.obrigatorio': 'Fill in this column',
  'importacao.vazia': 'The file has no rows to import',
  'servico.codigo_duplicado': 'A service with this code already exists',
  'servico.financeiro_ausente': 'Install Finance to choose a default cost center and category',
  'servico_contratado.nao_encontrado': 'Contracted service not found',
  'servico_contratado.inativo': 'The contracted service is inactive',
  'servico_contratado.em_uso': 'The contracted service is in use. Check the records before continuing',
  'servico_contratado.financeiro_ausente': 'Install Finance to choose the expense category',
  'servico_contratado.categoria_nao_despesa': 'Choose an expense category from the chart of accounts',
  'servico_contratado.parceiro_nao_fornecedor': 'The chosen partner is not a supplier',
  // Fase 2, W18.
  'servico.agenda_ausente': 'Install the Schedule to choose who does the service',
  'servico.nao_agendavel': 'The service is not marked as bookable in Records > Services > Service catalog',
  'projeto.cliente_ambiguo': 'There is more than one partner with this name; use the CPF or CNPJ in the cliente column',
  'projeto.nome_ambiguo': 'There is more than one project with this name; adjust the name on screen before importing',
  'tipo_cobranca.invalido': 'Choose recurring or one-off',
  'uso.invalido': 'Choose sale, purchase or both',
  // Fase 2, W10 (Tarefas).
  'card.mesma_coluna': 'The card is already in this column',
  'card.modulo_alvo_invalido': 'Choose an installed module, Core or New module',
  'card.nao_encontrado': 'Card not found',
  'card.coluna_excluida': "This card's column was deleted: the card has nowhere to go back to",
  'card.quadro_arquivado': "This card's board was also archived: undo the board deletion first",
  'categoria.pai_na_lixeira': 'The parent category was also deleted: undo its deletion first',
  'projeto.em_uso': 'The project is in use in another module and cannot be deleted',
  'card.responsavel_invalido': 'The assignee must be an active member of the workspace',
  'coluna.em_uso': 'The column has {{quantidade}} card(s). Move the cards before deleting it.',
  'coluna.limite_wip': 'The column already has {{ocupacao}} of {{limite}} cards (WIP limit)',
  'coluna.lista_incompleta': 'Send every column of the board, each one once',
  'coluna.nao_encontrado': 'Column not found on this board',
  'coluna.nome_duplicado': 'There is already a column with this name on the board',
  'coluna.ultima': 'The board needs at least one column',
  'permissao.aprovacao_humana': 'Only the approver, in their own session, can move the card to this column. API keys and agents never approve.',
  'quadro.nao_encontrado': 'Board not found',
  'quadro.nome_duplicado': 'There is already a board with this name',
  'quadro.sem_colunas': 'The board has no columns',
  // Fase 2 (W5): pessoas e empresas, dados fiscais, contas bancárias, consulta de CNPJ e CEP, campos personalizados.
  'ajuda.invalida': 'Field help has up to 200 characters',
  'consulta.conflito': 'The same lookup was saved at the same time. Try again.',
  'conta_bancaria.banco_obrigatorio': 'Enter the bank',
  'conta_bancaria.banco_codigo_invalido': 'Bank code with up to 20 letters or digits',
  'conta_bancaria.campo_longo': 'Text longer than this field accepts',
  'conta_bancaria.chave_pix_invalida': 'The Pix key does not match the chosen type',
  'conta_bancaria.chave_pix_obrigatoria': 'Enter the Pix key of the chosen type',
  'conta_bancaria.chave_pix_tipo_invalido': 'Invalid Pix key type',
  'conta_bancaria.conta_tipo_invalido': 'Invalid account type',
  'conta_bancaria.iban_invalido': 'Invalid IBAN',
  'conta_bancaria.iban_so_exterior': 'IBAN and SWIFT only for records outside Brazil',
  'conta_bancaria.swift_invalido': 'Invalid SWIFT (8 or 11 characters)',
  'conta_bancaria.titular_documento_invalido': 'Invalid account holder document',
  'documento.estrangeiro_invalido': 'Invalid home country registration: use letters without accents, digits and punctuation',
  'documento.estrangeiro_longo': 'The home country registration has up to 30 characters',
  'endereco.campo_longo': 'Text longer than this address field accepts',
  'endereco.cep_invalido': 'ZIP code must have 8 digits',
  'enderecos.nao_encontrado': 'Address not found',
  'endereco.cidade_obrigatoria': 'Enter the city',
  'endereco.logradouro_obrigatorio': 'Enter the street',
  'endereco.tipo_invalido': 'Invalid address type',
  'endereco.uf_invalida': 'Invalid state',
  'fiscal.campo_longo': 'Text longer than this field accepts',
  'fiscal.capital_invalido': 'Invalid share capital',
  'fiscal.conflito': 'The tax data was saved at the same time by someone else. Try again.',
  'fiscal.data_invalida': 'Invalid date',
  'fiscal.ie_nao_confere': 'The state registration does not match the rule of the main address state',
  'fiscal.inscricoes_invalidas': 'Up to 20 registrations of up to 60 characters',
  'fiscal.porte_invalido': 'Invalid company size',
  'fiscal.situacao_invalida': 'Invalid registration status',
  'moeda_padrao.invalida': 'Currency must be the 3-letter code (ISO 4217)',
  'pais.invalido': 'Country must be the 2-letter code (ISO 3166)',
  'regime.conflito': 'There is already a tax regime in force for this record',
  'regime.data_invalida': 'Invalid regime date: the end cannot be before the start',
  'regime.invalido': 'Invalid tax regime',
  'regime.nao_encontrado': 'Regime not found',
  'regime.sobreposto': 'The period overlaps another regime already entered',
  'vinculo.duplicado': 'This link already exists',
  'vinculo.mesmo_parceiro': 'A record cannot be linked to itself',
  'vinculo.nao_encontrado': 'Link not found',
  // Fase 2 (W16): vínculo do funcionário por empresa.
  'vinculo.encerrado': 'This employment link has already ended',
  'vinculo.ja_existe': 'This person already has an open employment link in this company',
  'vinculo.principal_pela_ficha': 'The main employment link changes through the employee record (Edit, Place on leave, Terminate)',
  'visivel_quando.invalido': 'Invalid display condition: choose another field of this entity and the value',
  // Fase 2 (W11): assistentes, aprovações, passkeys e lixeira.
  'aprovacao.acao_indisponivel': 'The action no longer exists in this version of the system',
  'aprovacao.expirada': 'This approval expired: the action was not done',
  'aprovacao.ja_decidida': 'This approval was already decided',
  'aprovacao.nao_encontrado': 'Approval not found',
  'aprovacao.prova_invalida': 'The confirmation was not accepted. Try again',
  'aprovacao.prova_obrigatoria': 'Confirm with your passkey or with the authenticator app code',
  'assistente.chave_invalida': 'The assistant key was revoked, the assistant is suspended or its owner was deactivated',
  'assistente.confirmacao_necessaria': 'Sensitive action: only with confirmation from the assistant owner',
  'assistente.escopo_invalido': 'Invalid module in the assistant scope',
  'assistente.escopo_obrigatorio': 'Choose at least one module for the assistant',
  'assistente.escopo_reservado': 'Roles, keys and settings are reserved to the person: the assistant can only read these modules',
  'assistente.fora_do_horario': 'Outside the hours allowed for this assistant',
  'assistente.horario_incompleto': 'Fill in both the start and the end of the allowed hours, or neither',
  'oauth.pedido_invalido': 'Invalid authorization request: start again from the client',
  'permissao.csrf_invalido': 'The authorization screen expired: open it again from the client',
  'permissao.oauth_desligado': 'OAuth connections are turned off in this workspace (Integrations > MCP)',
  'escopo.acima_da_pessoa': 'You can only grant what you can do yourself',
  'oauth.limite_conexoes': 'The workspace reached the limit of active OAuth connections',
  'oauth.conexao_nao_encontrado': 'OAuth connection not found',
  'assistente.de_oauth': 'This assistant is an OAuth connection: to change it, connect again from the client',
  'assistente.limite': 'You reached the limit of active assistants',
  'assistente.limite_diario': 'Daily action limit of this assistant reached',
  'assistente.nao_encontrado': 'Assistant not found',
  'assistente.nao_suspenso': 'The assistant is not suspended',
  'assistente.nivel_reservado': 'Action reserved to the person, directly on screen: the assistant never does it',
  'assistente.nivel_travado': 'This action is reserved to the person and its level cannot change',
  'assistente.permissao_invalida': 'Unknown write permission',
  'assistente.revogado': 'Assistant revoked: create another one',
  'assistente.so_pessoa': 'This action cannot be prepared for confirmation: do it directly on screen',
  'assistente.suspenso': 'Assistant suspended: the owner needs to reactivate it in My account, My assistants',
  'assistente.valor_acima': 'Amount above the per operation cap of this assistant',
  'chave.de_assistente': 'An assistant key is generated by its owner in My account, My assistants',
  'lixeira.entidade_desconhecida': 'This kind of record has no trash',
  'lixeira.nao_encontrado': 'Record not found in the trash',
  'lixeira.nao_excluido': 'The record is not deleted',
  'lixeira.prazo_vencido': 'The 30 day window to undo has passed',
  'passkey.desafio_invalido': 'The request expired or was already used. Start again',
  'passkey.duplicada': 'This passkey is already registered',
  'passkey.invalida': 'The passkey could not be confirmed. Try again',
  'passkey.limite': 'Limit of 10 passkeys per person',
  'passkey.nao_encontrado': 'Passkey not found',
  'condicao_pagamento.inativa': 'The payment terms are inactive',
  'contrato.cadastros_ausente': 'The Records module is not installed',
  'contrato.centro_nao_encontrado': 'Cost center not found',
  'unidade_recorrencia.invalida': 'Recurrence must be by day, week or month',
  'intervalo_meses.invalido': 'Use a whole number from 1 to 60',
  'contrato.cliente_nao_encontrado': 'No customer with this tax ID in Records',
  'contrato.termino_passado': 'This contract term has already ended; create a new contract',
  'contrato.confirmacao_obrigatoria': 'Confirm ending the contract: the scheduled billings will be canceled',
  'contrato.conflito': 'Conflict while saving the contract, try again',
  'contrato.contas_ausente': 'The Accounts module is not installed',
  'contrato.desconto_duplo': 'Use a discount amount or a percentage, not both',
  'contrato.desconto_excede': 'The discount must be lower than the cycle amount',
  'contrato.encerrado': 'The contract has ended',
  'contrato.encerramento_antes_do_inicio': 'The end cannot be before the start',
  'contrato.estado_invalido': 'This cannot be done in the contract\'s current status',
  'contrato.fim_antes_da_primeira': 'The end cannot be before the first billing',
  'contrato.fim_antes_do_inicio': 'The end date cannot be before the start',
  'contrato.fim_cobrancas_obrigatorio': 'Enter the number of billings',
  'contrato.fim_data_obrigatoria': 'Enter the end date',
  'contrato.itens_demais': 'Use at most 200 items per contract',
  'contrato.nao_ativo': 'Only an active contract bills',
  'plano.nao_encontrado': 'Plan not found',
  'plano.nome_obrigatorio': 'Give the plan a name',
  'plano.sem_itens': 'Add at least one item to the plan',
  'plano.itens_demais': 'Use at most 100 items per plan',
  'plano.nome_duplicado': 'A plan with this name already exists in this company',
  'plano.conflito': 'A plan with this id already exists',
  'plano.em_uso': 'This plan already created contracts: deactivate it instead of deleting',
  'plano.inativo': 'Inactive plan: activate it or choose another',
  'plano.outra_empresa': 'The plan belongs to another company: choose a plan of the contract company',
  'contrato.nao_encontrado': 'Contract not found',
  'contrato.primeira_cobranca_antiga': 'The first billing can be at most 12 months before today',
  'contrato.referencia_duplicada': 'A contract with this reference already exists',
  'contrato.sem_itens': 'Add at least one item to the contract',
  'contrato.servico_nao_encontrado': 'No active sales service with this code in the catalog',
  'contrato.item_ordem_invalida': 'Item order: use 1, 2, 3...',
  'contrato.so_rascunho': 'Only a draft contract can be deleted. End the others',
  'contrato.vendedor_invalido': 'The salesperson must be an active workspace user',
  'desconto.invalido': 'Invalid discount',
  'faturamento.erro': 'The invoice could not be issued now',
  'fim_tipo.invalido': 'Invalid contract term',
  'indice.invalido': 'Invalid adjustment index',
  'momento_pagamento.invalido': 'Invalid payment timing',
  'reajuste.decidido': 'This adjustment has already been decided',
  'reajuste.nao_encontrado': 'Adjustment not found',
  // Portal do Cliente (Onda 1).
  'arquivo.muito_grande': 'File larger than 25 MB',
  'arquivo.prazo_esgotado': 'The upload took too long to arrive. Try again (preferably on a better connection)',
  'arquivo.tipo_nao_permitido': 'File type not allowed (send a PDF, image, spreadsheet, document or invoice XML)',
  'arquivo.vazio': 'Empty file',
  'contato.nao_encontrado': 'This contact does not belong to this client',
  'conversa.outro_cliente': 'Conversation of another client',
  'dispositivo.invalido': 'Invalid push subscription',
  'portal.acesso_existente': 'This person already has access to this client. Use "Resend invitation".',
  'portal.acesso_ja_revogado': 'The access is already revoked',
  'portal.acesso_nao_convidado': 'Only a pending invitation can be resent',
  'portal.acesso_nao_encontrado': 'Access not found',
  'portal.acesso_nao_revogado': 'Only revoked access can be reactivated',
  'portal.area_invalida': 'Area outside your access',
  'portal.bloqueado': 'Too many attempts. Try again later.',
  'portal.codigo_invalido': 'Wrong or expired code',
  'portal.confirmacao_incorreta': 'Type your e-mail to confirm',
  'portal.convite_invalido': 'Invalid or expired invitation',
  'portal.credenciais_invalidas': 'Wrong e-mail or password',
  'portal.empresa_nao_encontrada': 'Company not found',
  'portal.entrega_nao_encontrada': 'Document not found',
  'portal.envio_nao_encontrado': 'Document not found',
  'portal.link_invalido': 'Invalid, used or expired link. Ask for a new one.',
  'portal.link_outro_aparelho': 'This link only works on the device where you asked for it. Type the e-mail code.',
  'portal.nao_autenticado': 'Sign in to the portal again',
  'portal.nao_configurado': 'The portal address for this workspace is not configured on the server (PORTAL_URL or, in the Sandbox, PORTAL_SANDBOX_URL)',
  'portal.nao_encontrado': 'Not found',
  'portal.senha_atual_incorreta': 'Wrong current password',
  'portal.somente_leitura': 'Team view: read only',
  'portal.termo_mudou': 'The terms changed: read the new version',
  'portal.termo_obrigatorio': 'Accept the terms of use to sign in',
  'portal.termo_pendente': 'Accept the terms of use to continue',
  'portal.termo_ausente': 'Publish the portal terms of use before inviting (Sales > Client portal > Portal settings)',
  'portal.envio_limite': 'Client upload limit in the portal (30 per hour and 300 MB per day)',
  'portal.email_da_equipe': 'This e-mail belongs to someone on the team. Invite the client person\'s e-mail',
  'portal.confirmacao_obrigatoria': 'Confirm with the current password or with the code sent to the client\'s e-mail',
  'portal.mensagem_limite': 'Client message limit in the portal (60 per hour)',
  'portal.termo_versao_existente': 'There is already a version with this name',
  'portal.teto_convites': '3 e-mails already went to this person in the last hour. Try later.',
  'portal.ver_como_invalido': 'Invalid or expired view link',
  'portal.passkey_invalida': 'Passkey not recognized. Sign in with the e-mail code.',
  'portal.passkey_desafio_invalido': 'The registration request expired or was already used. Start again.',
  'portal.passkey_duplicada': 'This passkey is already registered',
  'portal.passkey_limite': 'Limit of 10 passkeys per account',
  'conector.duble_proibido': 'The Conta Azul test double (fictitious data) only works in the Sandbox workspace or outside production',
  'conta_azul.nao_conectado': 'Connect and authorize Conta Azul in Integrations > Connectors',
  'conta_azul.rodada_aberta': 'A Conta Azul sync is already queued or running',
  'conta_azul.escolha_todas': 'Pick "My verticals" (top filter or the page\'s Company field) to map the cost centers (the change reaches entries of all companies)',
  'conta_azul.centro_repetido': 'Each cost center appears once in the map',
  'conta_azul.centro_nao_encontrado': 'Cost center not in the mirror: sync Conta Azul first',
  'conta_azul.empresa_nao_encontrada': 'Company not found',
  'contaazul.rede': 'Could not reach Conta Azul: try again in a moment',
  'contaazul.expirado': 'Conta Azul refused the authorization. Authorize again in Integrations > Connectors',
  'contaazul.token_recusado': 'Conta Azul refused the token request: check the app Client ID and Client Secret',
  'contaazul.sem_autorizacao': 'Conta Azul is not authorized yet: use the Authorize button',
  'contaazul.recurso_negado': 'Conta Azul denied access to this resource (403): check that the plan and the user who authorized have it',
  'contaazul.nao_encontrado': 'Record not found at Conta Azul',
  'contaazul.resposta_http': 'Conta Azul answered with an error: try again later',
  'contaazul.resposta_ilegivel': 'Unreadable answer from Conta Azul (truncated body or not JSON)',
  'contaazul.teto_paginas': 'Conta Azul listing above the page limit: nothing was marked as removed',
  'contaazul.falha_inesperada': 'Unexpected failure reading Conta Azul',
  'contaazul.erro': 'Conta Azul error',
  'ciclo.membro_invalido': 'Choose active members of the workspace',
  'ciclo.tarefas_ausente': 'The Tasks module is not installed',
  'onboarding.encerrado': 'The onboarding has already ended',
  'onboarding.nao_encontrado': 'Onboarding not found',
  'onboarding_etapa.conflito': 'This step already exists',
  'onboarding_etapa.nao_encontrado': 'Step not found',
  'onboarding_etapa.tipo_duplicado': 'The template already has this automatic step',
  'onboarding_etapa.titulo_obrigatorio': 'Give the step a title',
  'onboarding_passo.nao_encontrado': 'Step not found',
  'oportunidade.itens_demais': 'Up to 50 items per opportunity',
  'palavra_chave.limite': 'At most 200 active automatic replies: deactivate or remove one first',
  'presenca.invalida': 'Say whether you are Available or Away',
  'oportunidade.valor_dos_itens': 'With items, the opportunity value is their sum: change the items',
  'permissao.ciclo_exige_todas': 'Only who sees all companies changes the customer cycle and the onboarding template',
  'situacao_comercial.invalida': 'Sales status must be lead, customer or former customer',
  'ausencia.conflito_periodo': "There is already time off requested or approved in this period",
  'ausencia.estado_invalido': "This time off request is no longer open",
  'ausencia.ja_iniciado': "The approved time off has already started: it can no longer be canceled",
  'ausencia.nao_encontrado': "Time off request not found",
  'ausencia.periodo_invalido': "The end comes before the start",
  'ausencia.periodo_longo': "Period too long",
  'ausencia.saldo_insuficiente': "Not enough balance: {{disponivel}} day(s) available in the year",
  'ausencia.sem_dias': "The period has no working day to deduct",
  'permissao.aprovacao_propria': "You cannot decide your own request. Ask someone else who approves",
  'tipo_ausencia.categoria_invalida': "Invalid category",
  'tipo_ausencia.contagem_invalida': "Count must be in calendar or working days",
  'tipo_ausencia.em_uso': "This type has requests or balances: deactivate it instead of deleting",
  'tipo_ausencia.inativo': "This time off type is deactivated",
  'tipo_ausencia.nao_encontrado': "Time off type not found",
  'tipo_ausencia.nome_duplicado': "There is already a time off type with this name",
  'tipo_ausencia.saldo_invalido': "Yearly balance from 0 to 366 days (empty = no limit)",
  'despesa.categoria_receita': "Choose an expense category",
  'despesa.contas_indisponivel': "Install the Receivables and payables module to reimburse expenses",
  'despesa.data_futura': "The expense date cannot be after today",
  'despesa.empresas_diferentes': "A reimbursement belongs to a single company",
  'despesa.estado_invalido': "This expense can no longer be changed in this status",
  'anexo.indisponivel': "File storage unavailable. Try again in a moment",
  'assinatura.envio_pendente': "The provider has not received the sending yet: wait a moment",
  'assinatura.nativa': "This signature belongs to MalgoOS, not to a provider",
  'assinatura.nome_incompleto': "Clicksign requires the signer's first and last name",
  'assinatura.pelo_provedor': "This signature is collected by the provider: each person signs through the email they received",
  'assinatura.provedor_desconectado': "The signature provider is not connected: connect it in Integrations > Connectors or choose another provider",
  'assinatura.provedor_so_pdf': "Through the provider, only PDFs can be signed: upload the document version as PDF",
  'assinatura.signatario_do_provedor': "Through the provider, each person signs by email; in the MalgoOS signature, signers are team members or client people with Portal access",
  'assinatura.signatario_sem_email': "Enter a valid email for the signer: the provider sends the request by email",
  'clicksign.falha': "Clicksign refused or did not answer the request",
  'clicksign.assinado_indisponivel': "Clicksign has not released the signed file yet",
  'clicksign.prazo_longo': "Clicksign accepts deadlines of up to 90 days: change the deadline and send again",
  'clicksign.resposta': "Clicksign answered without what MalgoOS expected",
  'clicksign.sem_documento': "Sending without the Clicksign document",
  'documenso.falha': "Documenso refused or did not answer the request",
  'documenso.resposta': "Documenso answered without what MalgoOS expected",
  'documenso.sem_arquivo': "The Documenso envelope has no file",
  'documentos.provedor_obrigatorio': "Choose the signature provider",
  'assinatura.arquivo_sem_hash': "The document file has no SHA-256 hash: upload the version again",
  'assinatura.estado_invalido': "This signature does not accept this action in its current status",
  'assinatura.ja_decidida': "You have already answered this signature",
  'assinatura.nao_encontrado': "Signature not found",
  'assinatura.prazo_passado': "The deadline to sign cannot be before today",
  'assinatura.prazo_vencido': "The deadline to sign this document has passed",
  'assinatura.sem_comprovante': "The signature has not been sent yet: there is no trail to certify",
  'assinatura.sem_signatarios': "Choose at least one person to sign",
  'assinatura.signatario_invalido': "Signers must be team members or have active access to the Client portal",
  'assinatura.signatario_nao_encontrado': "You are not among the people who sign this document",
  'assinatura.signatario_repetido': "The same person appears twice in the list of signers",
  'assinatura.signatarios_demais': "At most 20 people per sending",
  'descricao.muito_longo': "The description is over 300 characters",
  'documento.assinado': "A signed document cannot be deleted: it is the proof of the signature",
  'documento.em_assinatura': "The document is being signed: cancel the sending first",
  'documento.registro_incompleto': "Give the record type and the record together",
  'documento.registro_tipo_invalido': "Invalid record type",
  'documento.tag_invalida': "Each tag has 1 to 40 characters",
  'documento.tags_demais': "At most 20 tags per document",
  'documento.versao_repetida': "This file is already the current version",
  'mensagem.muito_longo': "The note is over 2,000 characters",
  'conversor.indisponivel': "The PDF could not be generated right now. Try again in a moment.",
  'documento.campo_inexistente': "The template does not have this field",
  'documento.campos_pendentes': "Fill in the required fields of the document",
  'assinatura.assinante_invalido': "The chosen person is not an active workspace member with access to this company",
  'documento.contrato_sem_pdf': "The contract came out only as .docx (the server did not have the PDF converter yet): generate the document again to send it for signature",
  'documento.sem_modelo_docx': "This document was not generated from a .docx template for a contract: choose the signers by hand",
  'empresa.nao_encontrada': "Group company not found",
  'modelo.arquivo_ausente': "The template file is no longer available: upload the .docx again",
  'modelo.arquivo_grande': "The template .docx is over 5 MB",
  'modelo.arquivo_invalido': "The file is not a Word .docx the system can read",
  'modelo.campos_demais': "The template has too many fields",
  'modelo.campos_fora_de_ordem': "The template fields follow the file order",
  'modelo.campos_nao_conferem': "The map needs one item for each field of the file",
  'modelo.campos_so_docx': "The field map belongs to the .docx template",
  'modelo.chave_desconhecida': "Data the system does not know",
  'modelo.conflito_versao': "The template changed while the document was being generated: generate it again",
  'modelo.corpo_em_docx': "The .docx template has no text: replace the file",
  'modelo.evento_em_contrato': "Event belongs to an amendment or term, not a contract",
  'modelo.filtros_so_docx': "Type, event, company, services and regimes apply only to the .docx template",
  'modelo.formato_docx': "Word template: generate it from the contract, in Subscriptions",
  'modelo.formato_fixo': "The template format (text or .docx) does not change: create another template",
  'modelo.rotulo_invalido': "Each field needs a label of up to 120 characters",
  'modelo.tipo_errado': "This template is for an amendment or term, not a contract",
  'modelo.evento_errado': 'This template is not an amendment or term for this event',
  'modelo.antigos_em_contrato': '"Old contracts only" applies to an amendment or term, not to a contract',
  'documento.mudanca_so_formaliza': 'A tax regime change is only formalized: the regime changes in the client record',
  'documento.mudanca_fora_do_estado': 'With the contract in this status, this change does not apply on signature',
  'documento.data_antes_do_inicio': 'The effective date cannot be before the contract start',
  'documento.plano_obrigatorio': 'Choose the new plan of the migration',
  'documento.mesmo_plano': 'The contract is already on this plan',
  'documento.empresa_destino_obrigatoria': 'Choose the group company that receives the contract',
  'documento.cessao_mesma_empresa': 'The contract already belongs to this company: choose another group company',
  'documento.inadimplencia_so_formaliza': 'The non-payment term only formalizes it (it goes to the client as a notice): end the contract with "End contract"',
  'documento.contrato_em_dia': 'The contract is not overdue: the termination for non-payment term is only for a contract with an overdue invoice',
  'modelo.inativo': "Inactive contract template: activate it before generating",
  'modelo.nome_duplicado': "A contract template with this name already exists",
  'modelo.variavel_desconhecida': "The text has a variable the system does not fill in: check the variable list",
  'modelo.variavel_invalida': "Malformed variable: use double braces around the name, with lowercase letters, numbers and underscore",
  'motivo.obrigatorio': "Give the reason",
  'portal.indisponivel': "The client signs in the Client portal, which is not on in this workspace",
  'despesa.funcionario_sem_parceiro': "Link the employee to a record (People, employee file, Partner) to receive the reimbursement",
  'despesa.folha_indisponivel': "Install the Benefits and payroll module to reimburse through payroll",
  'despesa.competencia_obrigatoria': "Choose the payroll period that receives the reimbursement",
  'despesa.competencia_indisponivel': "The chosen payroll period no longer accepts entries (closed or outside your access)",
  'despesa.competencia_de_outra_empresa': "The payroll period belongs to another company: choose one from the expenses' company",
  'folha.reembolso_desativado': "The \"Expense reimbursement\" item is disabled in Payroll (People > Benefits and payroll > Items)",
  'variavel.de_outro_modulo': "This entry came from an expense reimbursement and cannot be removed in payroll",
  'despesa.funcionarios_diferentes': "A reimbursement belongs to a single employee",
  'despesa.nao_aprovada': "Only an approved expense goes to reimbursement",
  'despesa.nao_encontrado': "Expense not found",
  'despesa.periodo_invalido': "The end comes before the start",
  'despesa.sem_comprovante': "Attach the receipt before sending the expense",
  'despesa.valor_invalido': "The expense amount must be greater than zero",
  'despesa.vencimento_passado': "The reimbursement due date cannot be before today",
  // FUN 2026-10-15 (U7): Automações.
  'agenda.horario_repetido': 'A time appears more than once',
  'agenda.invalida': 'Invalid schedule',
  'agenda.janela_invertida': 'The start day comes after the end day',
  'agenda.sem_dia': 'Enter the day of the month',
  'agenda.sem_horario': 'Enter at least one time',
  'automacao.area_invalida': 'Invalid area',
  'automacao.area_sem_acesso': 'You cannot see this area',
  'automacao.avisos_demais': 'At most 50 people in the alert',
  'automacao.horas_sem_sinal': 'No signal hours from 1 to 168',
  'automacao.codigo_invalido': 'Code with lowercase letters, numbers and hyphen (2 to 60)',
  'automacao.etapa_invalida': 'Invalid flow box',
  'automacao.etapa_repetida': 'Two flow boxes with the same key',
  'automacao.etapas_demais': 'The flow has at most 40 boxes',
  'automacao.ja_pausada': 'The automation is already paused',
  'automacao.nao_encontrado': 'Automation not found',
  'automacao.nao_pausada': 'The automation is not paused',
  'automacao.pausada': 'Resume the automation before requesting a run',
  'execucao.etapa_invalida': 'Invalid step in the report',
  'execucao.etapas_demais': 'At most 40 steps in the report',
  'execucao.id_invalido': 'Run id with 1 to 100 characters',
  'execucao.placar_invalido': 'Invalid score',
  // U14 F1: automações de conversa (fluxos em canvas).
  'permissao.fluxo_exige_todas': 'This automation applies to all companies: only someone who sees all companies can change it',
  'caixa.canal': 'Choose the trigger channel',
  'caixa.modo_palavra': 'Choose how the keyword matches',
  'caixa.palavras_vazias': 'Enter at least one keyword',
  'caixa.palavras_demais': 'At most 20 keywords',
  'caixa.palavra_tamanho': 'Each keyword has 1 to 60 characters',
  'caixa.texto': 'Write the text (up to 1024 characters)',
  'caixa.arquivo_invalido': 'Invalid message file',
  'caixa.arquivo_canal': 'Files only go out on WhatsApp: keep the trigger on WhatsApp only or remove the file',
  'caixa.texto_instagram': 'On Instagram, the text above the buttons goes up to 640 characters',
  'caixa.post': 'Choose the post again from the list',
  'caixa.filtro_comentario': 'Choose whether any comment counts or only those with keywords',
  'caixa.respostas_demais_instagram': 'At most 13 quick replies on Instagram',
  'caixa.texto_direct': 'Write the private reply (up to 1000 characters)',
  'caixa.depois_privada': 'The Direct only accepts another message after the person replies: put buttons on the private reply and continue from the tap',
  'caixa.regra_segue_canal': '"Follows the account" only works on Instagram: keep the trigger on Instagram only',
  'fluxo.aviso_instagram_empresa': 'This automation\'s company has no Instagram of its own: a comment that arrives through the group Instagram runs only group automations. Connect the company Instagram in Integrations or create the automation in the group',
  'caixa.titulo_oportunidade': 'Opportunity title from 1 to 200 characters',
  'caixa.funil': 'Pipeline from 1 to 120 characters',
  'caixa.modo_botoes': 'Choose buttons or quick replies',
  'caixa.opcoes_vazias': 'Add at least one option',
  'caixa.botoes_demais': 'At most 3 buttons',
  'caixa.respostas_demais': 'At most 10 quick replies',
  'caixa.opcao_id': 'Option with an invalid or repeated identifier',
  'caixa.opcao_titulo': 'Each option has 1 to 20 characters',
  'caixa.opcao_repetida': 'Two options with the same text',
  'caixa.prazo': 'Deadline from 1 to 168 hours',
  'caixa.variavel_nome': 'Variable name: lowercase letters, numbers and _, starting with a letter',
  'caixa.formato': 'Choose the reply format',
  'caixa.mensagem_longa': 'Message too long',
  'caixa.juncao': 'Choose whether all rules or any rule must hold',
  'caixa.regras_vazias': 'Add at least one rule',
  'caixa.regras_demais': 'At most 10 rules',
  'caixa.regra_invalida': 'Invalid rule',
  'caixa.regra_variavel': 'Choose the rule variable',
  'caixa.regra_comparacao': 'Choose the rule comparison',
  'caixa.regra_valor': 'Enter the rule value',
  'caixa.regra_etiqueta': 'Enter the rule label',
  'caixa.regra_dias': 'Choose the rule weekdays',
  'caixa.regra_horario': 'Rule time: start before end (HH:MM)',
  'caixa.regra_canal': 'Choose the rule channel',
  'caixa.unidade': 'Choose the wait unit',
  'caixa.espera_limite': 'The wait goes from 1 minute to 30 days',
  'caixa.acao_etiqueta': 'Choose to add or remove the label',
  'caixa.etiqueta': 'Label with 1 to 30 characters',
  'caixa.fila': 'Invalid queue',
  'caixa.url': 'Webhook address: https://, no user or password, up to 500 characters',
  'desenho.laco': 'Loop with no wait: go through buttons, question or wait before going back',
  'fluxo.teste_outra_conversa': 'Test only in your own conversation: write from your phone and take the conversation',
  'caixa.config': 'Box settings are incomplete',
  'caixa.posicao': 'Invalid box position',
  'caixa.repetida': 'Repeated box',
  'caixa.solta': 'Box outside the trigger path',
  'desenho.caixas': 'Too many boxes in the drawing',
  'desenho.gatilho': 'The flow needs exactly one trigger',
  'desenho.invalido': 'Invalid drawing',
  'desenho.ligacoes': 'Too many connections in the drawing',
  'gatilho.solto': 'Connect the trigger to the first box',
  'ligacao.caixa': 'Connection to a box that does not exist',
  'ligacao.gatilho': 'Nothing connects back to the trigger',
  'ligacao.invalida': 'Invalid connection',
  'ligacao.repetida': 'Each output connects to one box only',
  'ligacao.saida': 'Connection from an output the box does not have',
  'conversas.indisponivel': 'The Conversations module is not installed',
  'execucao.ativa': 'The conversation already has an automation in progress',
  'execucao.encerrada': 'The run has already ended',
  'execucao.nao_encontrado': 'Run not found',
  'fluxo.arquivado': 'Unarchive the automation to change it',
  'fluxo.canal': 'The conversation is on a different channel from the automation',
  'fluxo.empresa': 'The conversation belongs to a different company from the automation',
  'fluxo.aviso_whatsapp_empresa': 'A company automation does not run on WhatsApp, whose conversations belong to the group: for WhatsApp, create the automation for the group (someone who sees all companies)',
  // U14 F5: Broadcast.
  'broadcast.sem_conversas': 'Conversations is not available',
  'broadcast.nao_encontrado': 'Broadcast not found',
  'broadcast.nao_editavel': 'Only a draft can change; a paused broadcast only changes its rate and limit',
  'broadcast.template_inexistente': 'Template not found: sync it in Conversations > Templates',
  'broadcast.template_nao_aprovado': 'The template has not been approved by Meta yet',
  'broadcast.template_categoria': 'Authentication templates cannot be broadcast',
  'broadcast.declaracao_pessoa': 'The spreadsheet declaration is made by a person, on the screen',
  'broadcast.fluxo_invalido': 'A button automation must belong to the group, be active and start with "Broadcast button click"',
  'broadcast.agendamento': 'Schedule from now up to 90 days ahead',
  'broadcast.publico_grande': 'The audience has more than 10 thousand contacts: split it into more than one broadcast',
  'broadcast.ninguem_recebe': 'Nobody in the audience can receive this template (consent, phone or variables)',
  'broadcast.estado_invalido': 'The broadcast is not in a state that accepts this command',
  'broadcast.variaveis': 'Link each template variable to a field, a column or a text',
  'broadcast.cabecalho': 'Fill in the template header',
  'broadcast.botao_parar': 'Marketing template: link a button to "Stop receiving"',
  'broadcast.botao_fluxo': 'Pick the button automation',
  'broadcast.botoes': 'Check the template buttons (link ending and code)',
  'broadcast.publico_vazio': 'Pick the audience',
  'fluxo.conflito': 'The automation was changed in another screen. Reload to continue.',
  'fluxo.grande': 'The drawing is over the maximum size',
  'fluxo.invalido': 'Fix the drawing issues before publishing',
  'fluxo.nao_arquivado': 'The automation is not archived',
  'fluxo.nao_ativo': 'Only an active automation can be paused',
  'fluxo.nao_encontrado': 'Automation not found',
  'fluxo.nome_repetido': 'There is already an automation with this name',
  'fluxo.sem_versao': 'Publish the automation first',
  'fluxo.teste_comentario': 'Comment automation: test by commenting on the post with the test account, or use "Simulate"',
  'caixa.antes_privada': 'Put the private reply before this box: the Direct with the commenter only opens with it',
  'caixa.resposta_repetida': 'One public and one private reply per comment',
  'caixa.so_comentario': 'Comment replies only with the "Post comment" trigger',
  'caixa.fonte_maton': 'Choose the event app',
  'caixa.evento_maton': 'Choose the app event',
  'caixa.conexao_maton': 'Choose the app account (Maton connection)',
  'caixa.gatilho_maton': 'Create the trigger at Maton ("Create at Maton" button)',
  'caixa.app_maton': 'Choose the app (Google Sheets or HubSpot)',
  'caixa.metodo_maton': 'Method not allowed (deleting is not allowed)',
  'caixa.caminho_maton': 'Enter the app API path, starting with /',
  'caixa.caminho_apaga': 'A call that deletes data is not allowed',
  'caixa.caminho_fora_lista': 'Call outside the allowed list for this app',
  'caixa.corpo_get': 'A GET call has no body',
  'caixa.corpo_json': 'Invalid JSON body: variables go inside the quotes of a text value',
  'caixa.corpo_longo': 'The body goes up to 4,000 characters',
  'caixa.sem_conversa_app': 'The external app event has no conversation: use only logic, webhook and external app action',
  'fluxo.teste_app': 'External app event automation: test by triggering the event in the app (Maton delivers it), or use "Simulate"',
  'conector.maton_evento': 'Event outside this app list',
  'conector.sem_endereco': 'The workspace has no webhook address',
  'maton.resposta': 'Maton answered in an unexpected format',
  'instagram.posts': 'Could not list the Instagram posts',
  'instagram.desconectado': 'Connect Instagram in Integrations to choose the post',
  'instagram.empresa_sem_conector': 'The company of this automation has no Instagram of its own: connect the company Instagram in Integrations or create the automation in the group',
  'instagram.sem_token': 'The Instagram connector has no access token: redo the connection in Integrations',
  'instagram.conta_sem_id': 'Fill in the account id (ig_user_id) in the Instagram connector in Integrations',
  'instagram.pagina_invalida': 'Invalid posts page: open the list again',
  'versao.nao_encontrado': 'Version not found',
  'feriado.duplicado': 'There is already a holiday on this date',
  'feriado.nao_encontrado': 'Holiday not found',
  'nome.obrigatorio': 'Enter the name',
  'pendencia.id_invalido': 'Item id with 1 to 100 characters',
  'pendencia.ja_aberta': 'This item is already open',
  'pendencia.ja_resolvida': 'This item is already resolved',
  'pendencia.ja_virou_tarefa': 'This item is already a task',
  'tarefas.nao_instalado': 'Install the Tasks module to create the task',
  'pendencia.nao_encontrado': 'Pending item not found',
  'pendencia.sem_titulo': 'Enter the item title',
  'robo.chave_invalida': 'Invalid or revoked robot key',
  'robo.reporte_desconhecido': 'Unknown report',
  'usuario.nao_encontrado': 'Person not found in the workspace',
  'projeto.sem_cadastros': "Projects need the Records module: install Records to create or link a project",
  'projeto.quadro_ja_existe': "This project already has a board in Tasks",
  'projeto.membro_invalido': "Each team member must be an active member of the workspace",
  'projeto.membro_responsavel': "Whoever owns an open task in the project stays on the team: change the owner first",
  'projeto.ja_arquivado': "The project is already archived",
  'projeto.nao_arquivado': "The project is not archived",
  'projeto.arquivado': "The project is archived: reopen it to work on tasks and milestones",
  'card.responsavel_fora_da_equipe': "The owner must be on the project team",
  'card.ja_concluido': "The task is already completed",
  'quadro.sem_coluna_concluida': "The board has no completed stage column",
  'marco.nao_encontrado': "Milestone not found",
  'marco.so_em_projeto': "Milestones only exist in projects (a board linked to a Records project)",
  'marco.ja_concluido': "The milestone is already completed",
  'marco.nao_concluido': "The milestone is not completed",
  'marco.quadro_arquivado': "This milestone's board was also archived: undo the board deletion first",
  'data.invalido': "Invalid date or outside 1900 to 2100",
  // Registro de ponto (lote 3, 21/10): relógio de ponto e AFD.
  'relogio.nao_encontrado': "Time clock not found",
  'relogio.serie_invalida': "Enter the time clock serial number",
  'relogio.endereco_invalido': "Use the clock address with https and no path (e.g. https://clock.company.com:8443)",
  'relogio.sem_api': "Automatic reading only exists for Control iD clocks; for the others, import the AFD",
  'relogio.sem_endereco': "Automatic reading needs the clock address",
  'relogio.serie_duplicada': "A time clock with this serial number already exists in this workspace",
  'relogio.empresa_obrigatoria': "Choose the clock company (the one of the AFD tax ID)",
  'relogio.duplicado': "A time clock with this id already exists",
  'relogio.em_uso': "This clock has an import queued or running: wait for it to finish before archiving",
  'relogio.inativo': "The time clock is inactive: activate it in its record",
  'relogio.sem_leitura_automatica': "Turn on automatic reading in the clock record (Control iD only, with the address)",
  'relogio.sem_conector': "Set up the Control iD connector (clock user and password) under Integrations > Connectors",
  'relogio.conflito_leitura': "A read of this clock is already queued or running",
  'relogio.inacessivel': "Could not reach the time clock: check the address and whether it is reachable over the internet",
  'relogio.certificado_diferente': "The clock certificate changed since the first read: check the clock and, if needed, forget the certificate in its record",
  'relogio.credencial_recusada': "The clock refused the Control iD connector user or password",
  'relogio.resposta': "The clock answered with an error when asked for the AFD",
  'relogio.endereco_bloqueado': "Clock address refused: it must be a public internet address",
  'relogio.grande': "The clock response exceeded the allowed size",
  'afd.vazio': "The file is empty",
  'afd.sem_cabecalho': "The file does not start with the AFD header (record type 1)",
  'afd.leiaute_desconhecido': "The header does not match the size of any AFD layout (Portaria 1510/2009 or 671/2021)",
  'afd.cabecalho_invalido': "AFD header without the identifier type or the employer tax ID",
  'afd.grande': "The file is larger than 20 MB",
  'afd.arquivo_grande': "The AFD is larger than 20 MB",
  'afd.arquivo_ausente': "The import file is no longer available",
  'afd.relogio_arquivado': "The time clock of this import was archived",
  'afd.empresa_sem_documento': "The clock company has no tax ID: add it under Settings > Companies",
  'afd.outra_empresa': "The tax ID in the AFD header is not the clock company one",
  'afd.outro_relogio': "The AFD comes from another clock: the manufacturing number in the header is not this record serial number",
  'afd.cabecalho_crc': "The AFD header CRC does not match: file corrupted or changed",
  'afd.importacao_duplicada': "This import was already requested",
  'afd.nao_encontrado': "Import not found",
  'afd.linha_invalida': "Line outside the AFD layout size",
  'afd.data_invalida': "Invalid punch date or time",
  'afd.documento_invalido': "Invalid employee CPF or PIS",
  'afd.nsr_repetido': "NSR repeated in the file: the first punch counts",
  'afd.registro_desconhecido': "Record that is not in the AFD layout",
  'afd.crc_invalido': "The line CRC does not match: line corrupted or changed",
  'afd.hora_futura': "Punch dated in the future: check the clock time",
  'afd.sem_pis': "The old layout (Portaria 1510) identifies by PIS, which People does not store: export the AFD in the Portaria 671 layout (with CPF)",
  'afd.sem_funcionario': "No employee with this CPF and a clock-in employment at the clock company on this day",
  'afd.periodo_fechado': "This month is already closed for the employee: reopen the month or request an adjustment",
  // Registro de ponto (lote 4, 21/10): REP-P e arquivos fiscais.
  'relogio.leitura_na_fila': "A read of this clock is already queued or running",
  'afd.importacao_nao_encontrada': "Import not found",
  'ponto.rep_p_sem_cpf': "Your record has no CPF and this company uses the official time clock (REP-P): ask HR to fill in the CPF",
  'ponto.rep_p_sem_documento': "Add the company tax ID under Settings > Companies before turning REP-P on",
  'ponto.rep_p_documento_invalido': "Enter the developer CNPJ (14 digits) or CPF (11)",
  'ponto.rep_p_caepf_invalido': "CAEPF has 14 digits and CNO, 12",
  'ponto.rep_p_indisponivel': "REP-P settings unavailable",
  'ponto.fiscal_sem_documento': "Add the company tax ID under Settings > Companies",
  'ponto.fiscal_sem_desenvolvedor': "Enter the program developer (tax ID, company name and email) under Fiscal files > Official time clock",
  'ponto.fiscal_sem_cpf': "There are {{funcionarios}} employee(s) without CPF in the period: complete their record in People",
  'ponto.fiscal_periodo_longo': "Period of up to 366 days",
  'ponto.fiscal_periodo_futuro': "The period starts in the future",
  'ponto.fiscal_duplicado': "This file was already generated",
  'ponto.comprovante_sem_certificado': "The employer has no digital certificate set up: the receipt comes out unsigned",
  'certificado.invalido': "The digital certificate file is not a valid PFX (PKCS#12)",
  'certificado.senha': "The digital certificate password does not match",
  'certificado.sem_chave': "The digital certificate has no private key (export the PFX with the key)",
  'certificado.vencido': "The digital certificate has expired: renew it and replace the PFX in the connector",
  'certificado.ainda_nao_valido': "The digital certificate is not valid yet",
  // Registro de ponto (lote 1, 19/10).
  'ajuste.conflito_desconsiderar': "There is already a request to disregard this punch",
  'ajuste.estado_invalido': "This time clock adjustment is no longer open",
  'ajuste.marcacao_de_outro': "The punch belongs to another employee",
  'ajuste.marcacao_obrigatoria': "Choose the punch to disregard",
  'ajuste.momento_antigo': "Adjustments only up to 90 days after the day",
  'ajuste.momento_futuro': "The punch to add cannot be in the future",
  'ajuste.momento_obrigatorio': "Enter the day and time of the punch to add",
  'ajuste.nao_encontrado': "Time clock adjustment not found",
  'ajuste.tipo_invalido': "Invalid adjustment type",
  'fechamento.estado_invalido': "This closing has already been reopened",
  'fechamento.ja_existe': "This company's time clock is already closed for this month",
  'fechamento.nao_encontrado': "Time clock closing not found",
  'horarios.invalidos': "Invalid schedule: use HH:MM, in the order start, break and end, on the same day and in multiples of 15 minutes",
  'marcacao.ajuste_obrigatorio': "An adjustment punch needs the approved adjustment",
  'marcacao.conflito_intervalo': "You just clocked in: wait a minute for the next punch",
  'marcacao.duplicada': "This punch has already been recorded",
  'marcacao.fora_de_linha_antiga': "Offline punch older than 7 days: request an adjustment",
  'marcacao.hora_aparelho_futura': "The device time is in the future: fix the phone clock",
  'marcacao.hora_aparelho_obrigatoria': "An offline punch needs the device time",
  'marcacao.localizacao_incompleta': "Enter latitude and longitude together",
  'marcacao.localizacao_invalida': "Invalid location",
  'marcacao.nao_encontrado': "Punch not found",
  'marcacao.origem_invalida': "Invalid punch source",
  'politica.banco_por_departamento': "The hour bank regime is set per company or per employee",
  'politica.cerca_incompleta': "An active geofence needs the center (latitude and longitude) and the radius in meters",
  'politica.nao_encontrado': "Policy not found",
  'ponto.conflito_ajustes_pendentes': "There are {{ajustes}} open time clock adjustment(s) in the month: decide them before closing",
  'ponto.conflito_fechamento_posterior': "A later month is closed: reopen the most recent one first",
  'ponto.conflito_folha_fechada': "This month's payroll is already closed: the time clock does not reopen",
  'ponto.conflito_marcacoes_incompletas': "There are days with an unpaired punch (in without out) for {{funcionarios}} employee(s): request or enter the adjustment before closing",
  'ponto.empresa_obrigatoria': "Choose the company to close its time clock",
  'ponto.fora_da_cerca': "You are outside the workplace ({{distancia_m}} m from the geofence point)",
  'ponto.foto_grande': "Photo over 512 KB",
  'ponto.foto_invalida': "The photo must be JPEG, PNG or WebP",
  'ponto.foto_obrigatoria': "The punch needs a photo",
  'ponto.localizacao_obrigatoria': "The punch needs the location: allow access to location",
  'ponto.periodo_em_aberto': "Only a finished month can be closed",
  'ponto.periodo_fechado': "This month's time clock is already closed: ask HR for the correction",
  'ponto.periodo_incompleto': "Enter the first and the last day",
  'ponto.periodo_invalido': "The end comes before the start",
  'ponto.periodo_longo': "Period of up to 62 days",
  'ponto.sem_funcionarios': "No employee clocks in at this company in the month",
  'ponto.sem_vinculo_com_ponto': "Your employment does not use the time clock (the contract type is not in the time clock settings)",
  // Item 11 do lote de 19/10: chat do site.
  'chat_site.contato_obrigatorio': 'Enter your email or phone',
  'chat_site.lgpd_obrigatorio': 'Accept the terms to start the conversation',
  'chat_site.origem_recusada': 'This website cannot open this chat',
  'chat_site.sessao_invalida': 'Invalid chat session',
  'chat_site.widget_inexistente': 'Chat unavailable',
  'fila.em_uso_widget': 'The queue receives conversations from a website chat: change the widget queue before deleting',
  'widget.dominio_invalido': 'Invalid domain: use the website address (example.com) or the subdomain wildcard (*.example.com)',
  'widget.dominios_demais': 'Up to {{max}} domains per widget',
  'widget.fila_invalida': 'Queue not found',
  'widget.ja_existe': 'A widget with this id already exists',
  'widget.nao_encontrado': 'Widget not found',
  // CRM no novo desenho (lotes 2 a 4).
  'ata.lacuna': 'Fill in the [ ] parts of the example (or delete the ones that do not apply)',
  'ata.longa': 'The minutes have at most 10,000 characters',
  'ata.obrigatoria': 'Write the minutes or summary (at least 10 characters)',
  'atividade.agendada': 'Meeting booked in the Schedule: change the time in the Schedule',
  'contatos.demais': 'Up to 50 contact people per deal',
  'empresas_adicionais.demais': 'Up to 20 additional companies per deal',
  'empresas_adicionais.igual_principal': 'This is already the main company of the deal',
  'empresas_adicionais.nao_empresa': 'Choose a company record (not a person)',
  'empresa_adicional.nao_encontrado': 'The company is not an additional one in this deal',
  'descricao.longa': 'The description has at most 5,000 characters',
  'email.destinatario_fora': 'There is an address outside the deal\'s contacts: confirm sending to it',
  // Lote crm4 (L8 e L9): anexos e texto formatado do e-mail e da proposta.
  'email.anexo_grande': 'The attachments add up to more than 28 MB (or one file is over 25 MB)',
  'email.anexo_tipo': 'File type not allowed in the email: send an image, PDF, Word, Excel, PowerPoint, OpenDocument, TXT or CSV',
  'email.anexo_nao_encontrado': 'Attachment not found in the deal files',
  'email.anexos_demais': 'Attach up to 5 files',
  'email.limite_externos': 'In the last hour, e-mails already went to {{limite}} addresses outside the deal contacts: wait before sending to more outside addresses',
  'central.arquivo_nao_encontrado': 'File library item not found',
  'central.vertical_nao_encontrado': 'Vertical not found',
  'central.portfolio_em_uso': 'This file is already the portfolio of another option; remove it from there first',
  'central.limite': 'The file library holds up to 200 files; delete one before uploading another',
  'email.texto_obrigatorio': 'Write the email text',
  'texto.longo': 'Text too long',
  'item.desconto_maior': 'The discount exceeds the item value (value x quantity)',
  'proposta_modelo.nao_encontrado': 'Proposal template not found',
  'proposta_modelo.padrao': 'The default template cannot be deleted or unset without another one in its place',
  'proposta.nao_encontrado': 'Proposal not found',
  'proposta.sem_itens': 'Add a product to the deal to create the proposal',
  'proposta.status_obrigatorio': 'Choose the proposal status',
  'proposta_status.nao_encontrado': 'Proposal status not found or inactive',
  'proposta_status.duplicado': 'A status with this name already exists',
  'proposta_status.demais': 'Up to 30 proposal statuses per workspace',
  'proposta_status.em_uso': 'There are {{em_uso}} proposal(s) in this status; move them to another status first',
  'proposta_status.ultimo_do_estado': 'Each base state needs at least one active status; create or activate another one of this state first',
  'proposta_status.fabrica': "The base state of a default status doesn't change; create another status",
  'proposta_status.ordem_invalida': 'Send every status, each one once',
  'questionario.nao_encontrado': 'Questionnaire not found',
  'questionario.aplicacao_nao_encontrada': 'Questionnaire not found in the deal',
  'questionario.inativo': 'This questionnaire is disabled',
  'questionario.limite_aplicacoes': 'The deal already has the maximum number of questionnaires',
  'questionario.ja_concluido': 'This questionnaire is already completed; save it by completing',
  'questionario.obrigatoria': 'Answer the required questions',
  'questionario.pergunta_repetida': 'Repeated question in the questionnaire',
  'questionario.pergunta_invalida': 'Invalid question in the questionnaire: check the type and the options',
  'questionario.resposta_invalida': 'Invalid answer for the question',
  'questionario.sem_pontos': 'To qualify automatically, give points to the options of some question',
  'questionario.sem_faixas': 'Enter at least one score range',
  'questionario.faixa_invertida': 'In the range, the minimum is above the maximum',
  'questionario.faixa_fora': 'Range outside the possible score of the questionnaire',
  'questionario.faixa_sobreposta': 'Overlapping score ranges',
  'workflow.nao_encontrado': 'Workflow not found',
};
